import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.unshift.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-06495556"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "out-box"
};
const _hoisted_2 = {
  class: "content-box"
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "margin-bottom": "10px",
    "align-items": "end"
  }
};
const _hoisted_4 = {
  style: {
    "font-size": "22px",
    "color": "#232323"
  }
};
const _hoisted_5 = {
  key: 0,
  style: {
    "font-size": "15px",
    "color": "#777777",
    "margin-left": "5px"
  }
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Edit", -1));
const _hoisted_7 = {
  style: {
    "display": "flex",
    "flex": "1",
    "flex-direction": "column"
  }
};
const _hoisted_8 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_9 = {
  key: 0,
  style: {
    "font-size": "15px",
    "color": "#777777"
  }
};
const _hoisted_10 = {
  key: 1,
  style: {
    "font-size": "12px",
    "color": "#777777",
    "margin-left": "5px"
  }
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1"
  }
}, null, -1));
const _hoisted_12 = {
  style: {
    "flex": "1",
    "display": "flex",
    "margin-top": "10px",
    "overflow": "hidden"
  }
};
const _hoisted_13 = {
  style: {
    "width": "250px",
    "background-color": "#f7f7f7",
    "display": "none",
    "flex-direction": "column",
    "padding": "10px"
  }
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#777777"
  }
}, "Version", -1));
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_17 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "width": "220px"
  }
};
const _hoisted_18 = {
  style: {
    "margin-top": "5px"
  }
};
const _hoisted_19 = {
  style: {
    "width": "380px",
    "border": "1px solid #d7d4d4",
    "border-right": "0",
    "display": "flex",
    "flex-direction": "column",
    "overflow": "hidden"
  }
};
const _hoisted_20 = {
  style: {
    "height": "40px",
    "display": "flex",
    "align-items": "center",
    "justify-content": "end"
  }
};
const _hoisted_21 = {
  style: {
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Download", -1));
const _hoisted_23 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "overflow": "hidden",
    "flex": "1",
    "align-items": "center"
  }
};
const _hoisted_24 = {
  key: 0,
  style: {
    "display": "flex",
    "flex-direction": "column",
    "align-items": "center",
    "background-color": "#676a6d",
    "width": "200px",
    "height": "200px",
    "cursor": "pointer",
    "position": "relative",
    "justify-content": "center"
  }
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-v-0b5b9274": "",
  style: {
    "width": "35px",
    "height": "1px",
    "background-color": "white",
    "position": "absolute"
  }
}, null, -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-v-0b5b9274": "",
  style: {
    "width": "1px",
    "height": "35px",
    "background-color": "white",
    "position": "absolute"
  }
}, null, -1));
const _hoisted_27 = [_hoisted_25, _hoisted_26];
const _hoisted_28 = {
  key: 0,
  style: {
    "border": "1px solid #d7d4d4",
    "margin": "10px 20px 0px 20px",
    "flex-shrink": "0",
    "flex-direction": "column",
    "box-sizing": "border-box",
    "font-size": "12px",
    "color": "#777777",
    "padding": "10px",
    "overflow": "auto",
    "flex": "1",
    "width": "100%"
  }
};
const _hoisted_29 = {
  key: 0,
  style: {
    "display": "flex",
    "flex-shrink": "0",
    "flex-direction": "column",
    "overflow": "hidden",
    "width": "max-content"
  }
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "report-item-row"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "170px"
  }
}, "STORE LIST")], -1));
const _hoisted_31 = {
  class: "report-item-row"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "CITY", -1));
const _hoisted_33 = {
  class: "report-item-row"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "STORE", -1));
const _hoisted_35 = {
  class: "report-item-row"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "INTERACTIONS", -1));
const _hoisted_37 = {
  class: "report-item-row"
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "PARTICIPANTS", -1));
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "report-item-line"
}, null, -1));
const _hoisted_40 = {
  key: 1,
  style: {
    "display": "flex",
    "flex-shrink": "0",
    "flex-direction": "column",
    "overflow": "hidden",
    "width": "max-content"
  }
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "report-item-row"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "170px"
  }
}, "CITY RANKING")], -1));
const _hoisted_42 = {
  class: "report-item-row"
};
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "CITY", -1));
const _hoisted_44 = {
  class: "report-item-row"
};
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "RANK", -1));
const _hoisted_46 = {
  class: "report-item-row"
};
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "STORES", -1));
const _hoisted_48 = {
  class: "report-item-row"
};
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "INTERACTIONS", -1));
const _hoisted_50 = {
  class: "report-item-row"
};
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "PARTICIPANTS", -1));
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "report-item-line"
}, null, -1));
const _hoisted_53 = {
  class: "report-item-row"
};
const _hoisted_54 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "170px"
  }
}, "PROJECT NAME", -1));
const _hoisted_55 = {
  style: {
    "width": "140px"
  }
};
const _hoisted_56 = {
  class: "report-item-row"
};
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "STORE", -1));
const _hoisted_58 = {
  class: "report-item-row"
};
const _hoisted_59 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Tracking Dates Start", -1));
const _hoisted_60 = {
  class: "report-item-row"
};
const _hoisted_61 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Tracking Dates End", -1));
const _hoisted_62 = {
  class: "report-item-row"
};
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Period(days)", -1));
const _hoisted_64 = {
  class: "report-item-row"
};
const _hoisted_65 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "VENDOR", -1));
const _hoisted_66 = {
  key: 0,
  class: "report-item-row"
};
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ACTUAL SPENDING", -1));
const _hoisted_68 = {
  key: 0,
  style: {
    "height": "26px",
    "padding": "3px",
    "font-size": "12px"
  }
};
const _hoisted_69 = {
  class: "report-item-row"
};
const _hoisted_70 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Interaction total", -1));
const _hoisted_71 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "report-item-line"
}, null, -1));
const _hoisted_72 = {
  class: "report-item-row"
};
const _hoisted_73 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_74 = {
  class: "report-item-row"
};
const _hoisted_75 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Busiest day", -1));
const _hoisted_76 = {
  class: "report-item-row"
};
const _hoisted_77 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Interactions/day", -1));
const _hoisted_78 = {
  class: "report-item-row"
};
const _hoisted_79 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_80 = {
  class: "report-item-row"
};
const _hoisted_81 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Slowest day", -1));
const _hoisted_82 = {
  class: "report-item-row"
};
const _hoisted_83 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Interactions/day", -1));
const _hoisted_84 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "report-item-line"
}, null, -1));
const _hoisted_85 = {
  class: "report-item-row"
};
const _hoisted_86 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "WEEK analysis", -1));
const _hoisted_87 = {
  class: "report-item-row"
};
const _hoisted_88 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Sunday", -1));
const _hoisted_89 = {
  class: "report-item-row"
};
const _hoisted_90 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Monday", -1));
const _hoisted_91 = {
  class: "report-item-row"
};
const _hoisted_92 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Tuesday", -1));
const _hoisted_93 = {
  class: "report-item-row"
};
const _hoisted_94 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Wednesday", -1));
const _hoisted_95 = {
  class: "report-item-row"
};
const _hoisted_96 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Thursday", -1));
const _hoisted_97 = {
  class: "report-item-row"
};
const _hoisted_98 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Friday", -1));
const _hoisted_99 = {
  class: "report-item-row"
};
const _hoisted_100 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Saturday", -1));
const _hoisted_101 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "report-item-line"
}, null, -1));
const _hoisted_102 = {
  class: "report-item-row"
};
const _hoisted_103 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Month", -1));
const _hoisted_104 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "report-item-line"
}, null, -1));
const _hoisted_105 = {
  class: "report-item-row"
};
const _hoisted_106 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Week", -1));
const _hoisted_107 = {
  style: {
    "display": "flex",
    "flex": "1",
    "flex-direction": "column",
    "overflow": "hidden"
  }
};
const _hoisted_108 = {
  style: {
    "display": "flex",
    "overflow": "auto",
    "flex-direction": "column"
  }
};
const _hoisted_109 = {
  style: {
    "display": "flex",
    "gap": "22px",
    "min-height": "103px"
  }
};
const _hoisted_110 = {
  class: "summary-card"
};
const _hoisted_111 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "summary-title"
}, "Total Days", -1));
const _hoisted_112 = {
  class: "summary-total"
};
const _hoisted_113 = {
  class: "summary-card"
};
const _hoisted_114 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "summary-title"
}, "Total Interactions", -1));
const _hoisted_115 = {
  class: "summary-total"
};
const _hoisted_116 = {
  class: "summary-card"
};
const _hoisted_117 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "summary-title"
}, [/*#__PURE__*/_createTextVNode(" Daily Average "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("Interactions ")], -1));
const _hoisted_118 = {
  class: "summary-total"
};
const _hoisted_119 = {
  class: "summary-week-box"
};
const _hoisted_120 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "summary-week-title"
}, " Daily Average Interactions ", -1));
const _hoisted_121 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_122 = {
  class: "summary-week-card"
};
const _hoisted_123 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "summary-week-card-title"
}, "Sunday", -1));
const _hoisted_124 = {
  class: "summary-week-card-total"
};
const _hoisted_125 = {
  class: "summary-week-card"
};
const _hoisted_126 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "summary-week-card-title"
}, "Monday", -1));
const _hoisted_127 = {
  class: "summary-week-card-total"
};
const _hoisted_128 = {
  class: "summary-week-card"
};
const _hoisted_129 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "summary-week-card-title"
}, "Tuesday", -1));
const _hoisted_130 = {
  class: "summary-week-card-total"
};
const _hoisted_131 = {
  class: "summary-week-card"
};
const _hoisted_132 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "summary-week-card-title"
}, "Wednesday", -1));
const _hoisted_133 = {
  class: "summary-week-card-total"
};
const _hoisted_134 = {
  class: "summary-week-card"
};
const _hoisted_135 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "summary-week-card-title"
}, "Thursday", -1));
const _hoisted_136 = {
  class: "summary-week-card-total"
};
const _hoisted_137 = {
  class: "summary-week-card"
};
const _hoisted_138 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "summary-week-card-title"
}, "Friday", -1));
const _hoisted_139 = {
  class: "summary-week-card-total"
};
const _hoisted_140 = {
  class: "summary-week-card"
};
const _hoisted_141 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "summary-week-card-title"
}, "Saturday", -1));
const _hoisted_142 = {
  class: "summary-week-card-total"
};
const _hoisted_143 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "center"
  }
};
const _hoisted_144 = {
  style: {
    "display": "flex",
    "justify-content": "center",
    "padding": "0"
  }
};
const _hoisted_145 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Download", -1));
const _hoisted_146 = {
  style: {
    "display": "flex",
    "justify-content": "center",
    "padding": "0"
  }
};
const _hoisted_147 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Filter", -1));
const _hoisted_148 = {
  key: 0,
  style: {
    "display": "flex",
    "gap": "22px",
    "margin-top": "10px",
    "padding-top": "10px",
    "border-top": "1px solid #d7d4d4",
    "width": "max-content"
  }
};
const _hoisted_149 = {
  class: "summary-title"
};
const _hoisted_150 = {
  class: "summary-total"
};
const _hoisted_151 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "35px",
    "height": "1px",
    "background-color": "#3b71b8",
    "position": "absolute"
  }
}, null, -1));
const _hoisted_152 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "1px",
    "height": "35px",
    "background-color": "#3b71b8",
    "position": "absolute"
  }
}, null, -1));
const _hoisted_153 = [_hoisted_151, _hoisted_152];
const _hoisted_154 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin": "10px 0px",
    "height": "1px",
    "width": "100%",
    "background-color": "#d7d4d4"
  }
}, null, -1));
const _hoisted_155 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1",
    "overflow": "hidden"
  }
};
const _hoisted_156 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_157 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "15px",
    "color": "#777777"
  }
}, " Data range: ", -1));
const _hoisted_158 = {
  style: {
    "font-size": "12px",
    "color": "#777777",
    "margin-left": "5px"
  }
};
const _hoisted_159 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1"
  }
}, null, -1));
const _hoisted_160 = {
  style: {
    "flex": "1",
    "display": "flex",
    "flex-direction": "column",
    "overflow": "hidden",
    "margin-top": "10px"
  }
};
const _hoisted_161 = {
  style: {
    "flex": "1",
    "overflow": "hidden",
    "flex-direction": "column"
  }
};
const _hoisted_162 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "编辑", -1));
const _hoisted_163 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "删除", -1));
const _hoisted_164 = {
  style: {
    "height": "60px",
    "display": "flex",
    "justify-content": "end",
    "align-items": "end"
  }
};
const _hoisted_165 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_166 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Summary", -1));
const _hoisted_167 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1",
    "overflow": "hidden"
  }
};
const _hoisted_168 = {
  style: {
    "flex": "1",
    "display": "flex",
    "flex-direction": "column",
    "overflow": "hidden",
    "margin-top": "10px"
  }
};
const _hoisted_169 = {
  style: {
    "flex": "1",
    "overflow": "hidden",
    "flex-direction": "column"
  }
};
const _hoisted_170 = {
  style: {
    "height": "60px",
    "display": "flex",
    "justify-content": "end",
    "align-items": "end"
  }
};
const _hoisted_171 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_172 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Edit", -1));
const _hoisted_173 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_174 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_175 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "New Summary", -1));
const _hoisted_176 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "margin": "20px 0px"
  }
};
const _hoisted_177 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_178 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "88px"
  }
}, "Summary Title:", -1));
const _hoisted_179 = {
  style: {
    "margin-left": "108px",
    "height": "20px",
    "font-size": "12px",
    "color": "red"
  }
};
const _hoisted_180 = {
  key: 0
};
const _hoisted_181 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_182 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "88px"
  }
}, "Summary Field:", -1));
const _hoisted_183 = {
  style: {
    "margin-left": "108px",
    "height": "20px",
    "font-size": "12px",
    "color": "red"
  }
};
const _hoisted_184 = {
  key: 0
};
const _hoisted_185 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_186 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "88px"
  }
}, "Data shown:", -1));
const _hoisted_187 = {
  style: {
    "display": "flex",
    "margin-left": "20px"
  }
};
const _hoisted_188 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_189 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_190 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Edit Report Range", -1));
const _hoisted_191 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "margin": "20px 0px"
  }
};
const _hoisted_192 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_193 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "88px"
  }
}, "Report Date:", -1));
const _hoisted_194 = {
  style: {
    "display": "flex",
    "margin-left": "20px"
  }
};
const _hoisted_195 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-left": "775px",
    "height": "20px",
    "font-size": "12px",
    "color": "red"
  }
}, null, -1));
const _hoisted_196 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_197 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "88px"
  }
}, "Activity Cycle:", -1));
const _hoisted_198 = {
  key: 0,
  style: {
    "width": "88px",
    "margin-left": "24px"
  }
};
const _hoisted_199 = {
  style: {
    "margin-left": "236px",
    "height": "20px",
    "font-size": "12px",
    "color": "red"
  }
};
const _hoisted_200 = {
  key: 0
};
const _hoisted_201 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_202 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "88px"
  }
}, "Please Select:", -1));
const _hoisted_203 = {
  style: {
    "margin-left": "378px",
    "height": "20px",
    "font-size": "12px",
    "color": "red"
  }
};
const _hoisted_204 = {
  key: 0
};
const _hoisted_205 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_206 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ex-dialog-title"
}, "封面裁剪", -1));
const _hoisted_207 = {
  style: {
    "width": "100%",
    "height": "432px"
  }
};
const _hoisted_208 = {
  style: {
    "display": "flex",
    "justify-content": "end",
    "padding": "20px 0px"
  }
};
const _hoisted_209 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "确认", -1));
const _hoisted_210 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "取消", -1));
const _hoisted_211 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_212 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Edit", -1));
const _hoisted_213 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "margin": "20px 0px"
  }
};
const _hoisted_214 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {}
}, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "display": "inline-block",
    "width": "200px"
  }
}, "Group By"), /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-left": "0px"
  }
}, "IsUserID")], -1));
const _hoisted_215 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "88px"
  }
}, "Summary Field", -1));
const _hoisted_216 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "width": "70px"
  }
};
const _hoisted_217 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "50px",
    "margin-left": "20px"
  }
}, "Type：", -1));
const _hoisted_218 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_219 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_220 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Report Date", -1));
const _hoisted_221 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "margin": "20px 0px"
  }
};
const _hoisted_222 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_223 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "88px",
    "margin-left": "24px"
  }
}, "Report Date:", -1));
const _hoisted_224 = {
  style: {
    "margin-left": "775px",
    "height": "20px",
    "font-size": "12px",
    "color": "red"
  }
};
const _hoisted_225 = {
  key: 0
};
const _hoisted_226 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_227 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_228 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Filter", -1));
const _hoisted_229 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "margin": "20px 0px"
  }
};
const _hoisted_230 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "88px"
  }
}, "Summary Field", -1));
const _hoisted_231 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "50px",
    "margin-left": "20px"
  }
}, "等于", -1));
const _hoisted_232 = {
  style: {
    "position": "relative",
    "flex": "1"
  }
};
const _hoisted_233 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "position": "absolute"
  }
}, null, -1));
const _hoisted_234 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "width": "70px"
  }
};
const _hoisted_235 = {
  key: 0,
  style: {
    "display": "flex",
    "align-items": "center",
    "margin-top": "10px"
  }
};
const _hoisted_236 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "50px",
    "margin-left": "20px"
  }
}, "等于", -1));
const _hoisted_237 = {
  style: {
    "position": "relative",
    "flex": "1"
  }
};
const _hoisted_238 = {
  key: 0,
  style: {
    "position": "absolute",
    "color": "red"
  }
};
const _hoisted_239 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "width": "70px"
  }
};
const _hoisted_240 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
import { ref, reactive, onMounted, getCurrentInstance, watch, nextTick, createVNode, h, computed, onBeforeUnmount } from "vue";
import util from "@/util/util";
import permission from "@/util/permission";
import { Modal, message, Divider, Button } from "ant-design-vue";
import { DownCircleOutlined, PlusOutlined, ExclamationCircleOutlined, CheckOutlined, EditOutlined, CloseOutlined } from "@ant-design/icons-vue";
import ResizePane from "@/components/ResizePane.vue";
import dayjs from "dayjs";
import { useRouter, useRoute, onBeforeRouteLeave } from "vue-router";
import showConfirmModal from "@/util//showConfirmModal";
import { VueCropper } from "vue-cropper";
import { genFileId } from "element-plus";
import axios from "axios";
import useClipboard from "vue-clipboard3";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import { ElNotification, ElMessageBox, ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/notification/style/css';
import 'element-plus/es/components/message-box/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  __name: 'ReportInteraction',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const {
      toClipboard
    } = useClipboard();
    const route = useRoute();
    const router = useRouter();
    const tokenData = util.getToken();
    // debugger;
    const itemId = route.params.itemId;
    const reportItemId = route.params.reportItemId;
    const activeTabsKey = ref("1");
    const activityReportItemData = reactive([]);
    const activityStatsItemStoreCodeData = reactive([]);
    const activityReportItemDetailData = reactive([]);
    const activityItemGroupAggData = reactive([]);
    const activityItemGroupAggColumnData = reactive([]);
    const groupRadio = ref(undefined);
    const activityItemGroupAggPagination = reactive({
      pageSizes: [25, 50, 100],
      currentPage: 1,
      totalSize: 2000,
      pageSize: 25
    });
    const dataTabsKey = ref("1");
    const numberTypes = ["bigint", "int", "double", "float", "decimal"];
    const reportContent = ref("");
    const currentActivityReportItem = ref(null);
    const reportContentSaveDisabled = ref(true);
    const reportContentIsEdit = ref(false);
    const reportContentRef = ref(null);
    const filterValueError = ref(false);
    const filterSearchError = ref(false);
    watch(reportContent, newContent => {
      if (reportContentRef.value) {
        // debugger;
        reportContentRef.value.contentWindow.document.open();
        reportContentRef.value.contentWindow.document.write(newContent);

        // 设置body的样式
        const iframeBody = reportContentRef.value.contentWindow.document.body;
        iframeBody.style.margin = "1rem";
        iframeBody.style.paddingTop = "30px";
        iframeBody.style.lineHeight = "1.4";
        iframeBody.style.wordBreak = "break-word";
        iframeBody.style.fontFamily = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif";
        reportContentRef.value.contentWindow.document.close();
      }
    });
    const activityStatsItemForm = ref(null);
    const activityStatsItemFormData = ref({});
    const activityStatsItemTable = ref(null);
    const activityStatsItemGroupAggTable = ref(null);
    const activityStatsItem = reactive({
      searchKeyword: null,
      data: []
    });
    const activityColumnData = reactive([]);
    const activityStatsItemPagination = reactive({
      pageSizes: [25, 50, 100],
      currentPage: 1,
      totalSize: 2000,
      pageSize: 25
    });
    const activityStatsItemOpen = ref(false);
    const activityStatsItemEditForm = ref(null);
    const activityStatsItemEditFormData = ref({});
    const interactionsStats = reactive({
      data: {}
    });
    const addSummaryOpen = ref(false);
    const summaryFormData = reactive({
      summaryTitle: null,
      fieldName: null,
      shownId: 1,
      activitySummaryItemId: null
    });
    const summaryValidMessage = reactive({
      summaryTitleError: null,
      fieldNameError: null
    });
    const addReportOpen = ref(false);
    const reportFormData = reactive({
      dateFastId: 1,
      activityCycle: true,
      dateRange: [],
      storeTypeId: null,
      storeCodes: []
    });
    const reportValidMessage = reactive({
      dateRangeError: null,
      storeCodeError: null
    });
    const storeTypeData = reactive([]);
    const filterStoreTypeData = reactive([]);
    const storeData = reactive([]);
    const storeOptions = reactive([]);
    const haveStoreData = reactive([]);
    const filterStoreData = reactive([]);
    const columnOptions = ref([]);
    const activitySummaryItemData = reactive([]);
    const validTypes = ["bigint", "int", "double", "float", "decimal"];
    const activityCoverDialogVisible = ref(false);
    const currentStatsItemUserType = ref(null);
    const coverCropper = ref(null);
    const activityCoverCropper = reactive({
      img: null,
      size: 1,
      full: true,
      outputType: "png",
      canMove: false,
      fixedBox: false,
      original: false,
      canMoveBox: true,
      autoCrop: true,
      centerBox: true,
      autoCropWidth: 200,
      autoCropHeight: 200,
      infoTrue: true,
      high: true,
      max: 99999,
      fixed: true,
      fixedNumber: [1, 1],
      limitMinSize: [200, 200]
    });
    const uploadActivityCover = ref(null);
    const uploadActivityCoverData = reactive({
      signatureData: {
        accessId: null,
        policy: null,
        signature: null,
        dir: null,
        host: "",
        expire: null,
        uuid: null
      },
      fileList: [],
      data: {},
      lastUpload: {},
      file: {
        url: null
      }
    });
    const itemGroupAggData = reactive({
      groupAgg: {}
    });
    const filterColumnGroupAggData = reactive({
      groupColumns: [],
      aggColumns: []
    });
    const updateGroupAggOpen = ref(false);
    const updateGroupAggOpen2 = ref(false);
    const updateGroupAggFormData = reactive({
      groups: [],
      aggs: []
    });
    const shownOptions = ref([{
      value: 1,
      label: "Highest"
    }, {
      value: 2,
      label: "Lowest"
    }, {
      value: 3,
      label: "Average"
    }, {
      value: 4,
      label: "Sum"
    }]);
    const downloadStatsItemData = reactive({
      dateRange: []
    });
    const downloadStatsItemValidMessage = reactive({
      dateRangeError: null
    });
    const downloadStatsItemOpen = ref(false);
    const onDownloadStatsItemOpen = () => {
      const startDate = dayjs(interactionsStats.data.activityStatsBegin, "YYYY/MM/DD");
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      var endDate = dayjs(`${year}/${month}/${day}`, "YYYY/MM/DD");
      if (interactionsStats.data.activityStatsEnd != null) {
        let activityStatsEnd = dayjs(interactionsStats.data.activityStatsEnd, "YYYY/MM/DD");
        if (activityStatsEnd.isBefore(endDate)) {
          endDate = activityStatsEnd;
        }
      }
      downloadStatsItemData.dateRange = [startDate, endDate];
      downloadStatsItemOpen.value = true;
    };
    const onDownloadStatsItemCancel = () => {
      downloadStatsItemData.dateRange = [];
      downloadStatsItemOpen.value = false;
    };
    const onDownloadStatsItemSubmit = () => {
      let activityStatsItemDownloadRO = {
        activityStatsItemId: itemId
      };
      if (downloadStatsItemData.dateRange.length == 2) {
        activityStatsItemDownloadRO.beginDate = dayjs(downloadStatsItemData.dateRange[0]).format("YYYY-MM-DD");
        activityStatsItemDownloadRO.endDate = dayjs(downloadStatsItemData.dateRange[1]).format("YYYY-MM-DD");
      }
      downloadActivityStatsItem(activityStatsItemDownloadRO);
      downloadStatsItemData.dateRange = [];
      downloadStatsItemOpen.value = false;
    };
    const getSignature = async directory => {
      return new Promise((resolve, reject) => {
        proxy.$api.authorizationRequest.getSignature(directory).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
      });
    };
    const handleActivityCoverOnChange = info => {
      const {
        file
      } = info;

      // if (!activityCoverDialogVisible.value) {
      //   return new Promise((resolve) => {
      //     const reader = new FileReader();
      //     reader.onload = (e) => {
      //       activityCoverCropper.img = e.target.result;
      //       resolve();
      //       activityCoverDialogVisible.value = true;
      //     };
      //     reader.readAsDataURL(file.originFileObj);
      //   });
      // }
    };

    const handleActivityCoverBeforeUpload = async (file, files, isUpload) => {
      if (!activityCoverDialogVisible.value) {
        return new Promise(resolve => {
          const reader = new FileReader();
          reader.onload = e => {
            activityCoverCropper.img = e.target.result;
            resolve();
            activityCoverDialogVisible.value = true;
          };
          reader.readAsDataURL(file);
        });
      }
      return false;
    };
    const customRequest = async ({
      file,
      onSuccess,
      onError,
      onProgress
    }) => {
      uploadActivityCoverData.signatureData = await getSignature("__temporary");
      let filename = file.name;
      let fullName = uploadActivityCoverData.signatureData.uuid + util.getSuffix(filename);
      let keyValue = uploadActivityCoverData.signatureData.dir + fullName;
      uploadActivityCoverData.data = {
        name: file.name,
        key: keyValue,
        policy: uploadActivityCoverData.signatureData.policy,
        OSSAccessKeyId: uploadActivityCoverData.signatureData.accessId,
        signature: uploadActivityCoverData.signatureData.signature,
        success_action_status: "200",
        onSuccess: file.uid
      };
      uploadActivityCoverData.lastUpload = {
        uid: file.uid,
        filename: fullName
      };
      // 阿里OSS上传逻辑
      const formData = new FormData();
      formData.append("key", uploadActivityCoverData.data.key);
      formData.append("policy", uploadActivityCoverData.data.policy);
      formData.append("OSSAccessKeyId", uploadActivityCoverData.data.OSSAccessKeyId);
      formData.append("success_action_status", uploadActivityCoverData.data.success_action_status);
      formData.append("signature", uploadActivityCoverData.data.signature);
      formData.append("file", file);
      axios.post(uploadActivityCoverData.signatureData.host, formData, {
        onUploadProgress: progressEvent => {
          const percent = Math.round(progressEvent.loaded * 100 / progressEvent.total);
          onProgress({
            percent
          });
        }
      }).then(response => {
        onSuccess(response.data);
      }).catch(error => {
        onError(error);
      });
    };
    const handleActivityCoverOnSuccess = async (response, file) => {
      if (file.status === "done") {
        let uploaded = {
          fileName: uploadActivityCoverData.data.name,
          uploadedName: uploadActivityCoverData.data.key
        };
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = e => {
          file.url = e.target.result;
          uploadActivityCoverData.file = file;
          activityCoverDialogVisible.value = false;
        };
        let activityItemCoverUpdateRO = {
          activityStatsItemId: itemId,
          coverUploaded: uploaded
        };
        updateActivityStatsItemCover(activityItemCoverUpdateRO);
      }
    };
    const handleActivityCoverExceed = fileList => {
      uploadActivityCoverData.fileList = [];
      // a-upload 没有 clearFiles 方法，所以需要手动清理文件列表
      uploadActivityCover.value = []; // 清空文件列表
      const file = fileList[0];
      file.uid = genFileId();
      // 将文件直接传递给 beforeUpload 处理
      handleActivityCoverBeforeUpload(file);
    };
    const getCoverCropBlobClick = () => {
      coverCropper.value.getCropBlob(async data => {
        let aTime = new Date().getTime();
        let fileName = aTime + "." + data.type.substr(6);
        let file = new window.File([data], fileName, {
          type: data.type
        });
        const resizedFile = await util.resizeImage(file, 200, 200);
        uploadActivityCoverData.fileList = [];

        // a-upload 没有 clearFiles 方法，所以需要手动清理文件列表
        uploadActivityCover.value = []; // 清空文件列表
        resizedFile.uid = genFileId();
        // 将文件直接传递给 beforeUpload 处理
        customRequest({
          file: resizedFile,
          onSuccess: response => handleActivityCoverOnSuccess(response, {
            status: "done",
            originFileObj: resizedFile
          }),
          onError: error => console.error("Upload failed", error),
          onProgress: event => console.log("Upload progress", event)
        });
        // handleActivityCoverBeforeUpload(resizedFile, null, true);
      });
    };

    const handleInput = e => {
      filterSearchError.value = false;
      let val = e.target.value;
      val = val.replace(/[^a-zA-Z0-9_.-\s]/g, '');
      const hasInvalidOr = /\sor\s/i.test(val);
      const hasInvalidAnd = /\sand\s/i.test(val);
      if (hasInvalidOr || hasInvalidAnd) {
        filterSearchError.value = true;
        e.target.value = filterSearch.value;
        return;
      }
      filterSearch.value = val;
      e.target.value = val;
    };
    const realTime = data => {
      const imgWidth = parseFloat(data.img.width);
      const imgHeight = parseFloat(data.img.height);
      if (imgWidth != 0 && imgHeight != 0 && data.w != 0 && data.h != 0) {
        let scale = 1.0;
        let matches = data.img.transform.match(/scale\(([-+]?\d*\.?\d+(?:[eE][-+]?\d+)?)\)/);
        if (matches && matches.length > 1) {
          let number = parseFloat(matches[1]);
          scale = number;
        }
        const minWidthScrop = 200 * scale;
        const minHiehgtScrop = 200 * scale;
        activityCoverCropper.limitMinSize = [minWidthScrop, minHiehgtScrop];
        const wScale = data.w / (imgWidth * scale);
        const hScale = data.h / (imgHeight * scale);
        const trueWidth = wScale * imgWidth;
        const trueHeight = hScale * imgHeight;
      }
    };
    onMounted(async () => {
      let activityStatsItem = await getActivityStatsItemRequest(itemId);
      currentStatsItemUserType.value = activityStatsItem.userType;
      await deleteReports();
      if (!permission.havePermission("互动数据", "查看数据报告") && !permission.havePermission("互动数据", "查看数据摘要")) {
        ElNotification({
          title: "Failure",
          message: "没有相关权限，不能进入",
          type: "error",
          duration: 3000
        });
        router.push({
          path: "/activity-browser"
        });
      }
      if (permission.havePermission("互动数据", "查看数据报告")) {
        activeTabsKey.value = "1";
      } else if (permission.havePermission("互动数据", "查看数据摘要")) {
        activeTabsKey.value = "2";
      }
      if (permission.havePermission("互动数据", "查看数据报告")) {
        let storeTypeList = await getStoreType();
        if (storeTypeList == null) {
          return;
        }
        storeTypeData.push(...storeTypeList);
        let storeList = await getStore();
        if (storeList == null) {
          return;
        }
        storeData.push(...storeList);
        storeOptions.push(...storeList.map(store => ({
          value: store.storeCode,
          label: store.storeName
        })));
        let activityReportItem = await getActivityReportItem(itemId);
        if (Array.isArray(activityReportItem)) {
          activityReportItemData.push(...activityReportItem);
          if (activityReportItem.length > 0) {
            let index = 0;
            if (reportItemId != null || reportItemId != "") {
              let findIndex = activityReportItemData.findIndex(element => element.activityReportItemId === Number(reportItemId));
              if (findIndex != -1) {
                index = findIndex;
              }
            }
            changeReportItemDetail(activityReportItem[index]);
          }
        }
        let interactionsStatsData = await getInteractionsStats(itemId);
        interactionsStats.data = interactionsStatsData;
        let currentTime = formattedCurrentTime;
        let endTime = interactionsStatsData.activityStatsEnd + " 00:00:00";
        if (endTime > currentTime) {
          interactionsStats.data.endCurrentTime = currentTime;
        } else {
          interactionsStats.data.endCurrentTime = endTime;
        }
        uploadActivityCoverData.file.url = interactionsStatsData.coverUrl;
        if (permission.havePermission("互动数据", "保存范围报告")) {
          let activityItemStoreCode = await getActivityStatsItemStoreCode(itemId);
          if (Array.isArray(activityItemStoreCode)) {
            activityStatsItemStoreCodeData.length = 0;
            activityStatsItemStoreCodeData.push(...activityItemStoreCode);
            haveStoreData.push(...storeData.filter(item => activityStatsItemStoreCodeData.includes(item.storeCode)));
            filterStoreData.push(...haveStoreData.map(store => ({
              value: store.storeCode,
              label: store.storeName
            })));
            filterStoreTypeData.push(...storeTypeData.filter(item => haveStoreData.some(stats => stats.storeTypeId === item.storeTypeId)));
          }
        }
      }
      if (permission.havePermission("互动数据", "查看数据摘要")) {
        if (!permission.havePermission("互动数据", "查看数据报告")) {
          let storeTypeList = await getStoreType();
          if (storeTypeList == null) {
            return;
          }
          storeTypeData.push(...storeTypeList);
          let storeList = await getStore();
          if (storeList == null) {
            return;
          }
          storeData.push(...storeList);
          filterStoreData.push(...storeData.map(store => ({
            value: store.storeCode,
            label: store.storeName
          })));
          storeOptions.push(...storeList.map(store => ({
            value: store.storeCode,
            label: store.storeName
          })));
          let interactionsStatsData = await getInteractionsStats(itemId);
          interactionsStats.data = interactionsStatsData;
        }
        itemGroupAggData.groupAgg = await getActivityStatsItemGroupAgg(itemId);
        if (itemGroupAggData.groupAgg && itemGroupAggData.groupAgg.groups.length > 0) {
          itemGroupAggData.groupAgg.groups.forEach((element, index) => {
            console.log(element, index);
            if (element.isUserId == 1) {
              groupRadio.value = index;
            }
          });
          getActivityStatsItemGroupAggByPage(1, activityItemGroupAggPagination.pageSize, itemId);
        }
        let activityColumn = await getActivityColumn(itemId);
        activityColumnData.push(...activityColumn);
        let activitySummaryItem = await getActivitySummaryItem(itemId);
        if (Array.isArray(activitySummaryItem)) {
          activitySummaryItemData.push(...activitySummaryItem);
        }
        getActivityStatsData(itemId, activityStatsItem.searchKeyword, 1, activityStatsItemPagination.pageSize);
      }
      watch(() => summaryFormData.shownId, async (newValue, oldValue) => {
        if (newValue === 3) {
          columnOptions.value.length = 0;
          columnOptions.value = activityColumnData.filter(item => validTypes.includes(item.type)).map(item => ({
            label: item.name,
            value: item.name
          }));
          if (Array.isArray(columnOptions.value) && !columnOptions.value.some(item => item.value === summaryFormData.fieldName)) {
            summaryFormData.fieldName = null;
          }
        } else {
          columnOptions.value.length = 0;
          columnOptions.value = activityColumnData.map(item => ({
            label: item.name,
            value: item.name
          }));
        }
      }, {
        immediate: true
      });
    });
    const onChangeReportItemDetail = async activityReportItem => {
      reportContentSaveDisabled.value = true;
      changeReportItemDetail(activityReportItem);
    };
    const onToCopyLink = async item => {
      let linkUrl = `${window.location.protocol}//${window.location.host}/report-interaction/${item.activityStatsItemId}/${item.activityReportItemId}`;
      await toClipboard(linkUrl); //实现复制
      console.log("Success");
      ElNotification({
        title: "成功",
        message: "复制到剪切板",
        type: "success",
        duration: 3000
      });
    };
    var oldReportName;
    const onEditReport = item => {
      oldReportName = item.activityReportItemName;
      item.edit = true;
    };
    const onSaveReport = item => {
      updateActivityReportItemName(item);
    };
    const onCancelReport = item => {
      item.activityReportItemName = oldReportName;
      item.edit = false;
    };
    const changeReportItemDetail = async activityReportItem => {
      console.log('activityReportItem:' + activityReportItem);
      console.log(activityReportItem);
      currentActivityReportItem.value = activityReportItem;
      // if (!permission.havePermission("互动数据", "保存范围报告")) {
      //   const editorBody = tinymce.activeEditor.getBody();
      //   editorBody.setAttribute("contenteditable", false);
      // }
      // nextTick(() => {
      //   tinymce.activeEditor.setContent("");
      // });

      let activityReportItemDetailRO = {
        activityReportItemId: activityReportItem.activityReportItemId
      };
      if (activityReportItem.activityReportItemId === 0) {
        activityReportItemDetailRO.activityStatsItemId = activityReportItem.activityStatsItemId;
      }
      if (currentActivityReportItem.value.reportUrl != null) {
        reportContent.value = await fetchTextFileContent(currentActivityReportItem.value.reportUrl);
        if (reportContent.value != undefined) {
          getActivityReportItemDetail(activityReportItemDetailRO);
        }
      } else {
        getActivityReportItemDetail(activityReportItemDetailRO);
      }
      nextTick(() => {
        let retries = 0;
        const maxRetries = 10;
        const checkEditor = () => {
          try {
            if (tinymce && tinymce.activeEditor) {
              tinymce.activeEditor.setContent(reportContent.value);
              console.log("TinyMCE is set content initialized.");
            } else if (retries < maxRetries) {
              retries++;
              setTimeout(checkEditor, 100); // 延时100毫秒后重试
            }
          } catch (error) {
            console.log("TinyMCE is not defined or not initialized.");
            if (retries < maxRetries) {
              retries++;
              setTimeout(checkEditor, 100); // 延时100毫秒后重试
            }
          }
        };

        checkEditor();
      });
    };
    const formattedCurrentTime = computed(() => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
    });
    const getColumnFormatter = (fieldName, columnData) => {
      return ({
        cellValue
      }) => {
        if (cellValue == null) {
          return null;
        }
        let column = columnData.find(column => column.name === fieldName) || null;
        if (column.type === "date") {
          return dayjs(cellValue).format("YYYY-MM-DD");
        } else if (column.type === "datetime") {
          return dayjs(cellValue).format("YYYY-MM-DD HH:mm:ss");
        }
        return cellValue;
      };
    };
    const getColumnFormatterValue = (fieldName, columnData) => {
      return ({
        cellValue
      }) => {
        if (cellValue == null) {
          return null;
        }
        let column = columnData.find(column => column.name === fieldName) || null;
        if (column.type === "date") {
          return dayjs(cellValue, "YYYY-MM-DD");
        } else if (column.type === "datetime") {
          return dayjs(cellValue, "YYYY-MM-DD HH:mm:ss");
        }
        return cellValue;
      };
    };
    const getStoreType = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getStoreType(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "失败",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    //获取所有店铺
    const getStore = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getStoreAll(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "失败",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    //单个活动表头
    const getActivityColumn = async itemId => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.getActivityColumn(itemId).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "1400") {
              resolve(res.result.data);
            } else {
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            ElNotification({
              title: "Failure",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "Error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };

    //获取活动项目报表项成功
    const getActivityReportItem = async itemId => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.getActivityReportItem(itemId).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "1501") {
              resolve(res.result.data);
            } else {
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            ElNotification({
              title: "Failure",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "Error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getInteractionsStats = async itemId => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.getInteractionsStats(itemId).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "2306") {
              resolve(res.result.data);
            } else {
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            ElNotification({
              title: "Failure",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "Error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const queryfilter = async data => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.queryfilter(data).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "1513") {
              resolve(res.result.dataCode);
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "success",
                duration: 3000
              });
            } else {
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            ElNotification({
              title: "Failure",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "Error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getActivityStatsItemRequest = async itemId => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.getActivityStatsItem(itemId).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "失败",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getActivityStatsData = async (activityStatsItemId, searchKeyword, currentPage, pageSize) => {
      let obj = {
        pageIndex: currentPage,
        pageSize: pageSize,
        data: {
          itemId: activityStatsItemId,
          searchKeyword: searchKeyword
        }
      };
      proxy.$api.activityStatsRequest.getActivityStatsData(obj).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "2100") {
            let activityStatsItems = res.result.data;
            activityStatsItemPagination.totalSize = activityStatsItems.totalCount;
            if (Array.isArray(activityStatsItems.pageList)) {
              activityStatsItem.data = activityStatsItems.pageList;
              for (let column of activityColumnData) {
                let maxWidth = getHTMLWidth(column.title);
                for (let item of activityStatsItem.data) {
                  let formatter = getColumnFormatter(column.name, activityColumnData);
                  item[column.name] = formatter({
                    cellValue: item[column.name]
                  });
                  if (item[column.name] != null && item[column.name] != "") {
                    let width = getHTMLWidth(item[column.name]);
                    if (width > maxWidth) {
                      maxWidth = width;
                    }
                  }
                }
                if (maxWidth > 0) {
                  column.width = Math.ceil(maxWidth) + 40;
                }
              }
            } else {
              activityStatsItem.data.length = 0;
            }
            if (Array.isArray(activityStatsItems.storeInfoListMap)) {
              activityStatsItem.storeInfoListMap = activityStatsItems.storeInfoListMap;
            }
            if (Array.isArray(activityStatsItems.cityRankListMap)) {
              activityStatsItem.cityRankListMap = activityStatsItems.cityRankListMap;
            }
          } else {
            ElNotification({
              title: "Failure",
              message: res.result.dataMsg,
              type: "error",
              duration: 3000
            });
          }
        } else {
          ElNotification({
            title: "Failure",
            message: res.msg,
            type: "error",
            duration: 3000
          });
        }
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {} else {
          ElNotification({
            title: "Error",
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };

    // 修改活动数据
    const editActivityStats = async infoDataMap => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.editActivityStats(infoDataMap).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "2200") {
              getActivityStatsData(itemId, activityStatsItem.searchKeyword, activityStatsItemPagination.currentPage, activityStatsItemPagination.pageSize);
              resolve(res.result);
              activityStatsItemEditForm.value.resetFields();
              activityStatsItemOpen.value = false;
              ElNotification({
                title: "Success",
                message: res.result.dataMsg,
                type: "success",
                duration: 3000
              });
            } else {
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            ElNotification({
              title: "Failure",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "Error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const removeActivityStatsItem = row => {
      showConfirmModal({
        title: "删除确认",
        content: "是否要删除这条记录？",
        okText: "删除",
        cancelText: "取消",
        onOk: () => {
          let activityStatsDelete = {
            itemId: itemId,
            id: row.id
          };
          deleteActivityStats(activityStatsDelete);
        }
      });
    };

    // 删除活动数据
    const deleteActivityStats = async activityStatsDelete => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.deleteActivityStats(activityStatsDelete).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "2300") {
              getActivityStatsData(itemId, activityStatsItem.searchKeyword, activityStatsItemPagination.currentPage, activityStatsItemPagination.pageSize);
              resolve(res.result);
              ElNotification({
                title: "Success",
                message: res.result.dataMsg,
                type: "success",
                duration: 3000
              });
            } else {
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            ElNotification({
              title: "Failure",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "Error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };

    // 更新活动项目封面
    const updateActivityStatsItemCover = async activityItemCoverUpdateRO => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.updateActivityStatsItemCover(activityItemCoverUpdateRO).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "1301") {
              // getActivityStatsData(
              //   itemId,
              //   activityStatsItem.searchKeyword,
              //   activityStatsItemPagination.currentPage,
              //   activityStatsItemPagination.pageSize
              // );

              resolve(res.result);
              ElNotification({
                title: "Success",
                message: res.result.dataMsg,
                type: "success",
                duration: 3000
              });
            } else {
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            ElNotification({
              title: "Failure",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "Error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const paginationCurrentActivityStatsItemChange = val => {
      getActivityStatsData(itemId, activityStatsItem.searchKeyword, val.currentPage, val.pageSize);
    };
    const getHTMLWidth = (htmlString, fontSize = "12px", fontFamily = "SourceHanSansCN-Regular") => {
      // 创建一个隐藏的span元素用于测量宽度
      let span = document.createElement("span");

      // 设置样式以确保测量结果的准确性
      span.style.position = "absolute";
      span.style.visibility = "hidden";
      span.style.whiteSpace = "nowrap";
      span.style.fontSize = fontSize;
      span.style.fontFamily = fontFamily;

      // 使用innerHTML插入HTML字符串
      span.innerHTML = htmlString;

      // 将测量元素添加到文档中
      document.body.appendChild(span);

      // 获取测量元素的宽度
      let width = span.getBoundingClientRect().width;

      // 从文档中移除测量元素
      span.remove();
      return width;
    };
    const editActivityStatsItem = row => {
      for (let column of activityColumnData) {
        let formatter = getColumnFormatterValue(column.name, activityColumnData);
        activityStatsItemEditFormData.value[column.name] = formatter({
          cellValue: row[column.name]
        });
      }
      activityStatsItemEditFormData.value.id = row.id;
      activityStatsItemOpen.value = true;
    };
    const onActivityStatsItemSave = () => {
      activityStatsItemEditForm.value.validate().then(async () => {
        let formData = JSON.parse(JSON.stringify(activityStatsItemEditFormData.value));
        for (let column of activityColumnData) {
          if (column.type == "datetime") {
            formData[column.name] = dayjs(formData[column.name]).format("YYYY-MM-DD HH:mm:ss");
          } else if (column.type == "date") {
            formData[column.name] = dayjs(formData[column.name]).format("YYYY-MM-DD");
          }
        }
        delete formData.store_name;
        let infoDataMap = {
          itemId: itemId,
          id: formData.id,
          data: [formData]
        };
        let addRes = await editActivityStats(infoDataMap);
      }).catch(error => {
        console.log("error", error);
      });
    };
    const onActivityStatsItemCancel = () => {
      activityStatsItemEditForm.value.resetFields();
      activityStatsItemOpen.value = false;
    };
    const onEdit = () => {
      router.push({
        path: "/create-interaction/" + itemId
      });
    };
    const onAddSummary = () => {
      summaryFormData.summaryTitle = null;
      summaryValidMessage.summaryTitleError = null;
      summaryFormData.fieldName = null;
      summaryValidMessage.fieldNameError = null;
      summaryFormData.shownId = 1;
      addSummaryOpen.value = true;
    };
    const onSummaryEdit = item => {
      summaryFormData.summaryTitle = item.summaryTitle;
      summaryFormData.fieldName = item.fieldName;
      summaryFormData.shownId = item.shownId;
      summaryFormData.activitySummaryItemId = item.activitySummaryItemId;
      summaryValidMessage.summaryTitleError = null;
      summaryValidMessage.fieldNameError = null;
      addSummaryOpen.value = true;
    };
    const onShownChange = shownId => {
      summaryFormData.shownId = shownId;
    };
    const onAddSummaryCancel = () => {
      summaryFormData.summaryTitle = null;
      summaryValidMessage.summaryTitleError = null;
      summaryFormData.fieldName = null;
      summaryValidMessage.fieldNameError = null;
      summaryFormData.shownId = 1;
      addSummaryOpen.value = false;
    };
    const onAddSummarySave = () => {
      if (!summaryFormData.summaryTitle) {
        summaryValidMessage.summaryTitleError = "Summary title cannot be empty";
      } else {
        summaryValidMessage.summaryTitleError = null;
      }
      if (!summaryFormData.fieldName) {
        summaryValidMessage.fieldNameError = "Field name cannot be empty";
      } else {
        summaryValidMessage.fieldNameError = null;
      }
      if (summaryValidMessage.summaryTitleError || summaryValidMessage.fieldNameError) {
        return;
      }
      let activitySummaryItemRO = {
        activityStatsItemId: itemId,
        activitySummaryItemId: summaryFormData.activitySummaryItemId,
        summaryTitle: summaryFormData.summaryTitle,
        fieldName: summaryFormData.fieldName,
        shownId: summaryFormData.shownId
      };
      if (summaryFormData.activitySummaryItemId != null) {
        let findIndex = activitySummaryItemData.findIndex(element => element.fieldName === activitySummaryItemRO.fieldName && element.shownId === activitySummaryItemRO.shownId && element.activitySummaryItemId !== activitySummaryItemRO.activitySummaryItemId);
        if (findIndex != -1) {
          ElNotification({
            title: "Failure",
            message: "Do not set repeatedly.",
            type: "error",
            duration: 3000
          });
          return;
        }
        updateActivitySummaryItem(activitySummaryItemRO);
      } else {
        let findIndex = activitySummaryItemData.findIndex(element => element.fieldName === activitySummaryItemRO.fieldName && element.shownId === activitySummaryItemRO.shownId);
        if (findIndex != -1) {
          ElNotification({
            title: "Failure",
            message: "Do not set repeatedly.",
            type: "error",
            duration: 3000
          });
          return;
        }
        addActivitySummaryItem(activitySummaryItemRO);
      }
    };
    const addActivitySummaryItem = async addActivitySummaryItemRO => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.addActivitySummaryItem(addActivitySummaryItemRO).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "2307") {
              activitySummaryItemData.push(res.result.data);
              resolve(res.result.data);
              addSummaryOpen.value = false;
            } else {
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            ElNotification({
              title: "Failure",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "Error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const updateActivitySummaryItem = async updateActivitySummaryItemRO => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.updateActivitySummaryItem(updateActivitySummaryItemRO).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "2310") {
              let activitySummaryItem = res.result.data;
              let findIndex = activitySummaryItemData.findIndex(element => element.activitySummaryItemId == activitySummaryItem.activitySummaryItemId);
              if (findIndex != -1) {
                activitySummaryItemData[findIndex] = activitySummaryItem;
              }
              resolve(res.result.data);
              addSummaryOpen.value = false;
            } else {
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            ElNotification({
              title: "Failure",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "Error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getActivitySummaryItem = async itemId => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.getActivitySummaryItem(itemId).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "2308") {
              resolve(res.result.data);
            } else {
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            ElNotification({
              title: "Failure",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "Error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const removeActivitySummaryItem = row => {
      showConfirmModal({
        title: "Warning",
        content: "Do you confirm deletion?",
        okText: "Delete",
        cancelText: "Cancel",
        onOk: () => {
          deleteActivitySummaryItem(row.activitySummaryItemId);
        }
      });
    };
    const deleteActivitySummaryItem = async summaryItemId => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.deleteActivitySummaryItem(summaryItemId).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "2309") {
              let findIndex = activitySummaryItemData.findIndex(element => element.activitySummaryItemId == summaryItemId);
              if (findIndex != -1) {
                activitySummaryItemData.splice(findIndex, 1);
              }
            } else {
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            ElNotification({
              title: "Failure",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "Error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const onCreateNew = () => {
      all();
      reportFormData.activityCycle = true;
      addReportOpen.value = true;
    };
    var reportContentCacheId = null;
    var reportContentCacheText = "";
    let isProcessing = false;
    const startReportContentCacheTimer = () => {
      reportContentCacheId = setInterval(async () => {
        if (isProcessing) {
          console.log("上一个请求还没完成，跳过当前请求");
          return;
        }
        const textContent = tinymce.activeEditor.getContent();
        if (textContent && textContent !== reportContentCacheText) {
          // console.log(
          //   "比较缓存不一样",
          //   ",textContent:" + textContent,
          //   ",reportContentCacheText:" + reportContentCacheText
          // );
          isProcessing = true;
          try {
            await updateReport(currentActivityReportItem.value.activityReportItemId, textContent);
            // 更新缓存文本内容
            reportContentCacheText = textContent;
          } catch (error) {
            console.log("Error fetching signature or uploading file:", error);
          } finally {
            // 请求完成后，重置标志位
            isProcessing = false;
          }
        } else {
          console.log("不需要缓存");
        }
      }, 10000);
    };

    // 停止定时器
    const stopReportContentCacheTimer = () => {
      if (reportContentCacheId) {
        clearInterval(reportContentCacheId);
        reportContentCacheId = null; // 确保计时器 ID 被清空
        console.log("定时器已停止");
      }
    };

    // 在路由离开时停止定时器
    onBeforeRouteLeave(() => {
      stopReportContentCacheTimer();
    });

    // 监听窗口关闭或刷新事件
    window.addEventListener("beforeunload", stopReportContentCacheTimer);

    // 确保在组件销毁时也停止定时器
    onBeforeUnmount(() => {
      stopReportContentCacheTimer();
      window.removeEventListener("beforeunload", stopReportContentCacheTimer);
    });

    // const startReportContentCacheTimer = () => {
    //   reportContentCacheId = setInterval(async () => {
    //     if (isProcessing) {
    //       console.log("上一个请求还没完成，跳过当前请求");
    //       return;
    //     }

    //     const textContent = tinymce.activeEditor.getContent();
    //     if (textContent !== reportContentCacheText) {
    //       debugger;

    //       console.log("需要缓存");

    //       isProcessing = true;

    //       try {
    //         const blob = new Blob([textContent], { type: "text/plain" });
    //         const file = new File(
    //           [blob],
    //           "report_item_" +
    //             currentActivityReportItem.value.activityReportItemId +
    //             ".txt",
    //           { type: "text/plain" }
    //         );

    //         const signatureData = await getSignature("report_content_cache");
    //         console.log("Signature:", signatureData);

    //         let keyValue =
    //           signatureData.dir + signatureData.uuid + util.getSuffix(file.name);
    //         signatureData.key = keyValue;

    //         const formData = new FormData();
    //         formData.append("key", signatureData.key);
    //         formData.append("policy", signatureData.policy);
    //         formData.append("OSSAccessKeyId", signatureData.accessId);
    //         formData.append("success_action_status", "200");
    //         formData.append("signature", signatureData.signature);
    //         formData.append("file", file);

    //         // 上传文件
    //         await axios.post(signatureData.host, formData, {
    //           onUploadProgress: (progressEvent) => {
    //             const percent = Math.round(
    //               (progressEvent.loaded * 100) / progressEvent.total
    //             );
    //             // onProgress({ percent });
    //           },
    //         });

    //         // 上传成功
    //         // onSuccess(response.data);

    //         // 更新缓存文本内容
    //         reportContentCacheText = textContent;
    //       } catch (error) {
    //         console.log("Error fetching signature or uploading file:", error);
    //       } finally {
    //         // 请求完成后，重置标志位
    //         isProcessing = false;
    //       }
    //     } else {
    //       console.log("不需要缓存");
    //     }
    //   }, 10000);
    // };

    // const stopReportContentCacheTimer = () => {
    //   if (reportContentCacheId) {
    //     clearInterval(reportContentCacheId);
    //     console.log("定时器已停止");
    //   }
    // };

    var previousReportContent = null;
    const onEditContent = async () => {
      if (reportContentIsEdit.value == true) {
        const textContent = tinymce.activeEditor.getContent();
        // debugger;
        if (textContent !== reportContent.value) {
          ElMessageBox.confirm("内容已被更改，取消将放弃更改内容", "询问", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            type: "warning"
          }).then(async () => {
            reportContentIsEdit.value = false;
            reportContentSaveDisabled.value = true;
            stopReportContentCacheTimer();
            reportContentCacheText = "";
            await deleteReportById(currentActivityReportItem.value.activityReportItemId);
            if (previousReportContent != null && previousReportContent.trim() != "") {
              reportContent.value = previousReportContent;
              previousReportContent = null;
            }
          }).catch(() => {
            ElMessage({
              type: "info",
              message: "中止取消"
            });
          });
        } else {
          reportContentIsEdit.value = false;
          reportContentSaveDisabled.value = true;
          startReportContentCacheTimer();
          await deleteReportById(currentActivityReportItem.value.activityReportItemId);
          if (previousReportContent != null && previousReportContent.trim() != "") {
            reportContent.value = previousReportContent;
            previousReportContent = null;
          }
        }
      } else {
        previousReportContent = null;
        reportContentIsEdit.value = true;
        reportContentSaveDisabled.value = false;
        reportContentCacheText = reportContent.value;
        startReportContentCacheTimer();
        await deleteReportById(currentActivityReportItem.value.activityReportItemId);
      }
    };
    const onSaveContent = async () => {
      const textContent = tinymce.activeEditor.getContent();
      const blob = new Blob([textContent], {
        type: "text/plain"
      });
      const file = new File([blob], "report.txt", {
        type: "text/plain"
      });
      const signatureData = await getSignature("__temporary");
      let keyValue = signatureData.dir + signatureData.uuid + util.getSuffix(file.name);
      signatureData.key = keyValue;
      const formData = new FormData();
      formData.append("key", signatureData.key);
      formData.append("policy", signatureData.policy);
      formData.append("OSSAccessKeyId", signatureData.accessId);
      formData.append("success_action_status", "200");
      formData.append("signature", signatureData.signature);
      formData.append("file", file);
      axios.post(signatureData.host, formData, {
        onUploadProgress: progressEvent => {}
      }).then(response => {
        reportContent.value = textContent;
        let reportContentUpdateRO = {
          activityReportItemId: currentActivityReportItem.value.activityReportItemId,
          contentUploaded: {
            fileName: file.name,
            uploadedName: signatureData.key
          }
        };
        updateReportContent(reportContentUpdateRO);
      }).catch(error => {
        ElNotification({
          title: "Failure",
          message: error,
          type: "error",
          duration: 3000
        });
      });
    };
    const onDelete = () => {
      showConfirmModal({
        title: "删除确认",
        content: "是否要删除这条记录？",
        okText: "删除",
        cancelText: "取消",
        onOk: () => {
          if (currentActivityReportItem != null) {
            let deleteActivityReportItemRO = {
              activityReportItemId: currentActivityReportItem.value.activityReportItemId
            };
            deleteActivityReportItem(deleteActivityReportItemRO);
          }
        }
      });
    };
    const fetchTextFileContent = async url => {
      try {
        const response = await axios.get(url, {
          responseType: "text"
        });
        return response.data;
      } catch (error) {
        console.error("There has been a problem with your fetch operation:", error);
      }
    };

    // 更新报告富文本内容
    const updateReportContent = async reportContentUpdateRO => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.updateReportContent(reportContentUpdateRO).then(async res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "1500") {
              currentActivityReportItem.value.reportUrl = res.result.data;
              reportContentIsEdit.value = false;
              reportContentSaveDisabled.value = true;
              stopReportContentCacheTimer();
              reportContentCacheText = "";
              await deleteReportById(currentActivityReportItem.value.activityReportItemId);
              resolve(res.result);
              ElNotification({
                title: "Success",
                message: res.result.dataMsg,
                type: "success",
                duration: 3000
              });
            } else {
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            ElNotification({
              title: "Failure",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "Error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const clearReportForm = () => {
      reportFormData.dateFastId = 1;
      reportFormData.dateRange = [];
      reportFormData.storeTypeId = null;
      reportFormData.storeCodes = [];
      filterStoreData.length = 0;
      filterStoreData.push(...haveStoreData.map(store => ({
        value: store.storeCode,
        label: store.storeName
      })));
      reportValidMessage.dateRangeError = null;
      reportValidMessage.storeCodeError = null;
    };
    const onDateFastChange = id => {
      reportFormData.dateFastId = id;
      if (id === 1) {
        all();
      } else if (id === 2) {
        thisWeek();
      } else if (id === 3) {
        lastWeek();
      } else if (id === 4) {
        thisMonth();
      } else if (id === 5) {
        lastMonth();
      }
    };
    const onReportItemCancel = () => {
      addReportOpen.value = false;
      clearReportForm();
    };
    const all = () => {
      const startDate = dayjs(interactionsStats.data.activityStatsBegin, "YYYY/MM/DD");
      let endDate = dayjs(interactionsStats.data.activityStatsEnd, "YYYY/MM/DD");
      let currentTime = formattedCurrentTime;
      let endTime = interactionsStats.data.activityStatsEnd + " 00:00:00";
      if (endTime > currentTime) {
        endDate = dayjs(interactionsStats.data.activityStatsEnd, "YYYY/MM/DD HH:mm:ss");
        interactionsStats.data.endCurrentTime = currentTime;
      }
      reportFormData.dateRange = [startDate, endDate];
    };
    const thisWeek = () => {
      const today = dayjs();
      // 获取本周的星期一
      const startOfWeek = today.startOf("week").add(1, "day"); // 假设周一为一周的开始
      // 获取本周的星期日
      const endOfWeek = today.endOf("week").add(1, "day"); // 假设周日为一周的结束
      // 设置日期范围
      reportFormData.dateRange = [startOfWeek, endOfWeek];
    };
    const lastWeek = () => {
      const today = dayjs();
      // 获取上一周的星期一
      const startOfLastWeek = today.startOf("week").subtract(6, "day"); // 假设上周一为一周的开始
      // 获取上一周的星期日
      const endOfLastWeek = today.startOf("week"); // 假设上周日为一周的结束
      // 设置日期范围
      reportFormData.dateRange = [startOfLastWeek, endOfLastWeek];
    };
    const thisMonth = () => {
      const today = dayjs();
      // 获取本月的第一天
      const startOfMonth = today.startOf("month");
      // 获取本月的最后一天
      const endOfMonth = today.endOf("month");
      // 设置日期范围
      reportFormData.dateRange = [startOfMonth, endOfMonth];
    };
    const lastMonth = () => {
      const today = dayjs();
      // 获取上个月的第一天
      const startOfLastMonth = today.subtract(1, "month").startOf("month");
      // 获取上个月的最后一天
      const endOfLastMonth = today.subtract(1, "month").endOf("month");
      // 设置日期范围
      reportFormData.dateRange = [startOfLastMonth, endOfLastMonth];
    };
    const onStoreTypeChange = value => {
      filterStoreData.length = 0;
      if (value == null) {
        filterStoreData.push(...haveStoreData.map(store => ({
          value: store.storeCode,
          label: store.storeName
        })));
      } else {
        filterStoreData.push(...haveStoreData.filter(store => store.storeTypeId == value).map(store => ({
          value: store.storeCode,
          label: store.storeName
        })));
      }
    };
    const onReportItemSave = () => {
      if (reportFormData.activityCycle !== true && (reportFormData.dateRange == null || reportFormData.dateRange.length != 2)) {
        reportValidMessage.dateRangeError = "Date range cannot be empty";
      } else {
        reportValidMessage.dateRangeError = null;
      }
      if (reportFormData.storeCodes.length == 0) {
        reportValidMessage.storeCodeError = "Store cannot be empty";
      } else {
        reportValidMessage.storeCodeError = null;
      }
      if (reportValidMessage.dateRangeError || reportValidMessage.storeCodeError) {
        return;
      }
      let addActivityReportItemRO = JSON.parse(JSON.stringify(reportFormData));
      if (reportFormData.activityCycle != true) {
        addActivityReportItemRO.activityReportBegin = dayjs(reportFormData.dateRange[0]).format("YYYY-MM-DD");
        addActivityReportItemRO.activityReportEnd = dayjs(reportFormData.dateRange[1]).format("YYYY-MM-DD");
      }
      addActivityReportItemRO.activityStatsItemId = itemId;
      addActivityReportItem(addActivityReportItemRO);
    };

    // 新增活动项目报表项
    const addActivityReportItem = async addActivityReportItemRO => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.addActivityReportItem(addActivityReportItemRO).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "1502") {
              resolve(res.result.data);
              activityReportItemData.unshift(res.result.data);
              changeReportItemDetail(res.result.data);
              addReportOpen.value = false;
              clearReportForm();
              ElNotification({
                title: "Success",
                message: res.result.dataMsg,
                type: "success",
                duration: 3000
              });
            } else {
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            ElNotification({
              title: "Failure",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "Error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };

    // 删除活动项目报表项
    const deleteActivityReportItem = async deleteActivityReportItemRO => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.deleteActivityReportItem(deleteActivityReportItemRO).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "1509") {
              resolve(res.result.data);
              let findIndex = activityReportItemData.findIndex(element => element.activityReportItemId === deleteActivityReportItemRO.activityReportItemId);
              if (findIndex != -1) {
                activityReportItemData.splice(findIndex, 1);
                if (activityReportItemData.length > 0) {
                  let index = 0;
                  if (reportItemId != null || reportItemId != "") {
                    let findIndex = activityReportItemData.findIndex(element => element.activityReportItemId === Number(reportItemId));
                    if (findIndex != -1) {
                      index = findIndex;
                    }
                  }
                  changeReportItemDetail(activityReportItemData[index]);
                } else {
                  tinymce.activeEditor.setContent("");
                  activityReportItemDetailData.length = 0;
                  currentActivityReportItem.value = null;
                }
              }
              ElNotification({
                title: "Success",
                message: res.result.dataMsg,
                type: "success",
                duration: 3000
              });
            } else {
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            ElNotification({
              title: "Failure",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "Error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };

    // 获取活动项目报表项
    const getActivityReportItemDetail = async activityReportItemDetailRO => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.getActivityReportItemDetail(activityReportItemDetailRO).then(async res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "1504") {
              activityReportItemDetailData.length = 0;
              if (Array.isArray(res.result.data)) {
                activityReportItemDetailData.push(...res.result.data);
                for (let item of activityReportItemDetailData) {
                  if (item.actualSpending == null) {
                    item.actualSpending = "";
                  }
                  item.actualSpending_ = item.actualSpending;
                }
              }
              const cacheContent = await getReportContent(currentActivityReportItem.value.activityReportItemId);
              if (cacheContent != null && cacheContent.trim() != "" && cacheContent != reportContent.value) {
                ElMessageBox.confirm("发现之前缓存的报告内容，要载入内容吗？取消会放弃之前缓存的内容，如果发现内容不对，请不要保存", "询问", {
                  confirmButtonText: "确认",
                  cancelButtonText: "取消",
                  type: "warning"
                }).then(async () => {
                  reportContentIsEdit.value = true;
                  reportContentSaveDisabled.value = false;
                  previousReportContent = reportContent.value;
                  reportContentCacheText = reportContent.value = cacheContent;
                  startReportContentCacheTimer();
                  await deleteReportById(currentActivityReportItem.value.activityReportItemId);
                }).catch(async () => {
                  ElMessage({
                    type: "info",
                    message: "放弃载入"
                  });
                  await deleteReportById(currentActivityReportItem.value.activityReportItemId);
                });
              }
              // reportContentIsEdit.value = false;
              // reportContentSaveDisabled.value = true;
              resolve(res.result.data);
            } else {
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            ElNotification({
              title: "Failure",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "Error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const onSaveActualSpending = (activityReportItemId, activityReportItemDetail) => {
      // debugger;
      updateReportItemActualSpending(activityReportItemId, activityReportItemDetail);
    };

    // 新增活动项目报表支出
    const updateReportItemActualSpending = async (activityReportItemId, activityReportItemDetail) => {
      let actualSpendingRO = {
        activityReportItemId: activityReportItemId,
        storeCode: activityReportItemDetail.storeCode,
        actualSpending: activityReportItemDetail.actualSpending
      };
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.updateReportItemActualSpending(actualSpendingRO).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "1505") {
              activityReportItemDetail.actualSpending_ = activityReportItemDetail.actualSpending;
              resolve(res.result.data);
            } else {
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            ElNotification({
              title: "Failure",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "Error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const filterStoreOption = (input, option) => {
      return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    };

    // 获取活动项目报分组聚合计算成功
    const getActivityStatsItemStoreCode = async activityReportItemId => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.getActivityStatsItemStoreCode(activityReportItemId).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "1511") {
              resolve(res.result.data);
            } else {
              resolve(null);
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            resolve(null);
            ElNotification({
              title: "Failure",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          resolve(null);
          ElNotification({
            title: "Error",
            message: error,
            type: "error",
            duration: 3000
          });
        });
      });
    };

    // 获取活动项目报分组聚合计算成功
    const getActivityStatsItemGroupAgg = async activityReportItemId => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.getActivityStatsItemGroupAgg(activityReportItemId).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "1506") {
              resolve(res.result.data);
            } else {
              resolve(null);
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            resolve(null);
            ElNotification({
              title: "Failure",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          resolve(null);
          ElNotification({
            title: "Error",
            message: error,
            type: "error",
            duration: 3000
          });
        });
      });
    };

    // 更新活动项目报分组聚合计算成功
    const updateActivityStatsItemGroupAgg = async activityStatsItemGroupAggUpdateRO => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.updateActivityStatsItemGroupAgg(activityStatsItemGroupAggUpdateRO).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "1507") {
              ElNotification({
                title: "成功",
                message: res.result.promptMsg,
                type: "success",
                duration: 3000
              });
              itemGroupAggData.groupAgg = res.result.data;
              getActivityStatsItemGroupAggByPage(1, activityItemGroupAggPagination.pageSize, itemId);
              updateGroupAggOpen.value = false;
              resolve(res.result.data);
            } else {
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            ElNotification({
              title: "Failure",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "Error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const activeTabsKeyChange = activityKey => {
      if (activityKey == "2" && itemGroupAggData.groupAgg.aggs.length == 0 && itemGroupAggData.groupAgg.groups.length == 0 && permission.havePermission("互动数据", "设置数据总结")) {
        updateGroupAggFormData.groups.length = 0;
        updateGroupAggFormData.groups.push({
          activityStatsItemGroupField: null
        });
        updateGroupAggFormData.aggs.length = 0;
        updateGroupAggFormData.aggs.push({
          activityStatsItemAggField: null,
          shownOptions: [],
          shownId: null
        });
        filterColumnGroupAgg();
        updateGroupAggOpen.value = true;
      }
    };
    const filterColumnGroupAgg = () => {
      filterColumnGroupAggData.groupColumns.length = 0;
      filterColumnGroupAggData.aggColumns.length = 0;
      filterColumnGroupAggData.groupColumns.push(...activityColumnData.filter(item => !updateGroupAggFormData.aggs.some(obj => obj.activityStatsItemAggField === item.name) && !updateGroupAggFormData.groups.some(obj => obj.activityStatsItemGroupField === item.name) && item.name !== "store_name").map(item => ({
        label: item.name,
        value: item.name
      })));
      filterColumnGroupAggData.aggColumns.push(...activityColumnData.filter(item => !updateGroupAggFormData.aggs.some(obj => obj.activityStatsItemAggField === item.name) && !updateGroupAggFormData.groups.some(obj => obj.activityStatsItemGroupField === item.name) && item.name !== "store_name").map(item => ({
        label: item.name,
        value: item.name
      })));
    };
    const onGroupColumnChange = () => {
      filterColumnGroupAgg();
    };
    const onAddGroupColumn = item => {
      if (item.activityStatsItemGroupField == null || item.activityStatsItemGroupField == "") {
        return;
      }
      updateGroupAggFormData.groups.push({
        activityStatsItemGroupField: null
      });
    };
    const onDecreaseGroupColumn = (item, index) => {
      console.log(index, groupRadio.value);
      showConfirmModal({
        title: "删除确认",
        content: "是否要删除这条记录？",
        okText: "删除",
        cancelText: "取消",
        onOk: () => {
          if (index <= groupRadio.value) {
            groupRadio.value = undefined;
          }
          if (updateGroupAggFormData.groups.length == 1) {
            item.activityStatsItemGroupField = null;
          } else {
            const index = updateGroupAggFormData.groups.indexOf(item);
            if (index !== -1) {
              updateGroupAggFormData.groups.splice(index, 1);
            }
          }
          filterColumnGroupAgg();
        }
      });
    };
    const onGroupAggChange = item => {
      filterColumnGroupAgg();
      shownSelectChange(item);
    };
    const onAddAggColumn = item => {
      if (item.activityStatsItemAggField == null || item.activityStatsItemAggField == "") {
        return;
      }
      updateGroupAggFormData.aggs.push({
        activityStatsItemAggField: null,
        shownOptions: [],
        shownId: null
      });
    };
    const onDecreaseAggColumn = item => {
      showConfirmModal({
        title: "删除确认",
        content: "是否要删除这条记录？",
        okText: "删除",
        cancelText: "取消",
        onOk: () => {
          if (updateGroupAggFormData.aggs.length == 1) {
            item.activityStatsItemAggField = null;
            item.shownId = 1;
          } else {
            const index = updateGroupAggFormData.aggs.indexOf(item);
            if (index !== -1) {
              updateGroupAggFormData.aggs.splice(index, 1);
            }
          }
          filterColumnGroupAgg();
        }
      });
    };
    const onGroupAggCancel = () => {
      updateGroupAggOpen.value = false;
    };
    const onGroupAggConfirm = () => {
      let activityStatsItemGroupAggUpdateRO = {
        activityStatsItemId: itemId,
        groups: updateGroupAggFormData.groups.filter(item => item.activityStatsItemGroupField !== null && item.activityStatsItemGroupField !== ""),
        aggs: updateGroupAggFormData.aggs.filter(item => item.activityStatsItemAggField !== null && item.activityStatsItemAggField !== "")
      };
      activityStatsItemGroupAggUpdateRO.groups.forEach((element, index) => {
        if (index == groupRadio.value) {
          element.isUserId = 1;
        } else {
          element.isUserId = 0;
        }
      });
      console.log(activityStatsItemGroupAggUpdateRO);
      updateActivityStatsItemGroupAgg(activityStatsItemGroupAggUpdateRO);
    };
    const onGroupAggEdit = () => {
      updateGroupAggFormData.groups.length = 0;
      updateGroupAggFormData.aggs.length = 0;
      if (dataTabsKey.value == "2" && itemGroupAggData.groupAgg.groups.length == 0 && itemGroupAggData.groupAgg.aggs.length == 0) {
        updateGroupAggFormData.groups.push({
          activityStatsItemGroupField: null
        });
        updateGroupAggFormData.aggs.push({
          activityStatsItemAggField: null,
          shownOptions: [],
          shownId: null
        });
      } else {
        updateGroupAggFormData.groups.push(...itemGroupAggData.groupAgg.groups.map(item => ({
          activityStatsItemGroupField: item.activityStatsItemGroupField
        })));
        if (itemGroupAggData.groupAgg.aggs != null && itemGroupAggData.groupAgg.aggs.length > 0) {
          updateGroupAggFormData.aggs.push(...itemGroupAggData.groupAgg.aggs.map(item => ({
            activityStatsItemAggField: item.activityStatsItemAggField,
            shownOptions: filterShownOptions(item.activityStatsItemAggField),
            shownId: item.shownId
          })));
        } else {
          updateGroupAggFormData.aggs.push({
            activityStatsItemAggField: null,
            shownOptions: [],
            shownId: null
          });
        }
      }
      filterColumnGroupAgg();
      updateGroupAggOpen.value = true;
    };
    const filterData = reactive({
      choose: [],
      noChoose: []
    });
    const filterSearch = ref('');
    const filterValue = ref(null);
    const onGroupAggFilter = () => {
      filterData.noChoose = JSON.parse(JSON.stringify(activityColumnData));
      ;
      updateGroupAggOpen2.value = true;
    };
    const addFilter = () => {
      if (filterSearch.value == '') {
        return;
      }
      if (filterValue.value == null) {
        return;
      }
      if (filterSearchError.value) {
        return;
      }
      for (let i = 0; i < filterData.noChoose.length; i++) {
        if (filterData.noChoose[i].name === filterValue.value) {
          filterData.noChoose[i].search = filterSearch.value;
          filterData.choose.push(filterData.noChoose[i]);
          filterData.noChoose.splice(i, 1);
          filterValue.value = null;
          filterSearch.value = '';
        }
      }
    };
    const deleteFilter = index => {
      console.log(index);
      filterData.choose[index].search = '';
      filterData.noChoose.push(filterData.choose[index]);
      filterData.choose.splice(index, 1);
    };
    const onGroupAggCancel2 = () => {
      filterData.choose.length = 0;
      filterData.noChoose.length = 0;
      filterValue.value = null;
      filterSearch.value = '';
      updateGroupAggOpen2.value = false;
    };
    const onGroupAggConfirm2 = async () => {
      if (filterValue.value == null) {
        filterValueError.value = true;
        return;
      }
      if (filterSearch.value == '') {
        filterSearchError.value = true;
        return;
      }
      if (filterSearchError.value) {
        return;
      }
      let filter = {};
      filter[filterValue.value] = filterSearch.value;
      filterData.choose.forEach(item => {
        filter[item.name] = item.search;
      });
      // let filter = filterData.choose.map(item => ({
      //     [item.name]: item.search
      // }));
      let data = {
        activityStatsItemId: itemId,
        filter: filter
      };
      let queryfilterMsg = await queryfilter(data);
      if (queryfilterMsg == "1513") {
        updateGroupAggOpen2.value = false;
        let activityReportItem = await getActivityReportItem(itemId);
        if (Array.isArray(activityReportItem)) {
          activityReportItemData.push(...activityReportItem);
          if (activityReportItem.length > 0) {
            let index = 0;
            if (reportItemId != null || reportItemId != "") {
              let findIndex = activityReportItemData.findIndex(element => element.activityReportItemId === Number(reportItemId));
              if (findIndex != -1) {
                index = findIndex;
              }
            }
            changeReportItemDetail(activityReportItem[index]);
          }
        }
        let interactionsStatsData = await getInteractionsStats(itemId);
        interactionsStats.data = interactionsStatsData;
      }
    };
    const shownSelectChange = item => {
      item.shownOptions = filterShownOptions(item.activityStatsItemAggField);
      item.shownId = item.shownOptions[0].value;
    };
    const filterShownOptions = name => {
      let findIndex = activityColumnData.findIndex(element => element.name === name);
      if (findIndex != -1) {
        if (numberTypes.includes(activityColumnData[findIndex].type)) {
          return shownOptions;
        }
      }
      return [{
        value: 1,
        label: "Highest"
      }, {
        value: 2,
        label: "Lowest"
      }];
    };
    const getActivityStatsItemGroupAggByPage = async (index, pageSize, itemId) => {
      let groupAggPageROPageInfo = {
        pageSize: pageSize,
        pageIndex: index,
        data: {
          activityStatsItemId: itemId
        }
      };
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.getActivityStatsItemGroupAggByPage(groupAggPageROPageInfo).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "1508") {
              let groupAggData = res.result.data.pageList[0];
              activityItemGroupAggPagination.totalSize = res.result.data.totalCount;
              activityItemGroupAggData.length = 0;
              activityItemGroupAggData.push(...groupAggData.data);
              activityItemGroupAggColumnData.length = 0;
              activityItemGroupAggColumnData.push(...groupAggData.columns);
              for (let column of activityItemGroupAggColumnData) {
                if (column.name === "total_record") {
                  column.title = "记录数";
                }
                let maxWidth = getHTMLWidth(column.title);
                for (let item of activityItemGroupAggData) {
                  let formatter = getColumnFormatter(column.name, activityItemGroupAggColumnData);
                  item[column.name] = formatter({
                    cellValue: item[column.name]
                  });
                  if (item[column.name] != null && item[column.name] != "") {
                    let width = getHTMLWidth(item[column.name]);
                    if (width > maxWidth) {
                      maxWidth = width;
                    }
                  }
                }
                if (maxWidth > 0) {
                  column.width = Math.ceil(maxWidth) + 40;
                }
              }
              if (activityStatsItemGroupAggTable && activityStatsItemGroupAggTable.value) {
                activityStatsItemGroupAggTable.value.reloadData(activityItemGroupAggData);
              }
              resolve(res.result.data);
            } else {
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            ElNotification({
              title: "Failure",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "Error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const paginationCurrentActivityItemGroupAggChange = val => {
      getActivityStatsItemGroupAggByPage(val.currentPage, val.pageSize, itemId);
    };
    const onStatsItemSearch = () => {
      getActivityStatsData(itemId, activityStatsItem.searchKeyword, 1, activityStatsItemPagination.pageSize);
    };
    const downloadActivityStatsItem = activityStatsItemDownloadRO => {
      getActivityStatsItemExport(activityStatsItemDownloadRO);
    };
    const getActivityStatsItemExport = itemId => {
      proxy.$api.activityStatsRequest.getActivityStatsItemExport(itemId).then(res => {}).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: "错误",
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };
    const downloadReportItemDetail = () => {
      if (currentActivityReportItem != null) {
        let activityReportItemDetailRO = {
          activityReportItemId: currentActivityReportItem.value.activityReportItemId
        };
        if (activityReportItemDetailRO.activityReportItemId === 0) {
          activityReportItemDetailRO.activityStatsItemId = currentActivityReportItem.value.activityStatsItemId;
        }
        getActivityReportItemDetailExport(activityReportItemDetailRO);
      }
    };
    const getActivityReportItemDetailExport = activityReportItemDetailRO => {
      proxy.$api.activityStatsRequest.getActivityReportItemDetailExport(activityReportItemDetailRO).then(res => {}).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: "错误",
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };

    // 使用 ref 创建一个响应式引用
    const reportItemDetail = ref(null);

    // 定义生成 PDF 的方法
    const generatePDF = async () => {
      if (reportItemDetail.value) {
        const canvas = await html2canvas(reportItemDetail.value, {
          useCORS: true,
          scale: 2,
          // 提高分辨率
          backgroundColor: null // 确保 PDF 背景颜色与网页相同
        });

        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = imgProps.height * pdfWidth / imgProps.width;
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save("document.pdf");
      }
    };
    const updateActivityReportItemName = async item => {
      let updateActivityReportItemNameRO = {
        activityReportItemId: item.activityReportItemId,
        activityReportItemName: item.activityReportItemName
      };
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.updateActivityReportItemName(updateActivityReportItemNameRO).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "1510") {
              item.edit = false;
              resolve(res.result.data);
            } else {
              ElNotification({
                title: "Failure",
                message: res.result.dataMsg,
                type: "error",
                duration: 3000
              });
            }
          } else {
            ElNotification({
              title: "Failure",
              message: res.msg,
              type: "error",
              duration: 3000
            });
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "Error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const downloadActivityReportItemContent = activityReportItemId => {
      let activityReportItemContentRO = {
        activityReportItemId: activityReportItemId
      };
      getActivityReportItemContent(activityReportItemContentRO);
    };
    const getActivityReportItemContent = activityReportItemContentRO => {
      proxy.$api.activityStatsRequest.getActivityReportItemContent(activityReportItemContentRO).then(res => {}).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: "错误",
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };

    // 创建并打开 IndexedDB 数据库
    const openDb = () => {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open("reportContentCache", 1);
        request.onupgradeneeded = event => {
          const db = event.target.result;
          if (!db.objectStoreNames.contains("reports")) {
            const store = db.createObjectStore("reports", {
              keyPath: "id"
            });
            store.createIndex("updateTime", "updateTime", {
              unique: false
            });
          }
        };
        request.onsuccess = event => resolve(event.target.result);
        request.onerror = event => reject(event.target.error);
      });
    };

    // 新增或修改记录
    const updateReport = async (id, reportContent) => {
      const db = await openDb();
      const transaction = db.transaction("reports", "readwrite");
      const store = transaction.objectStore("reports");
      const request = store.get(id);
      return new Promise((resolve, reject) => {
        request.onsuccess = event => {
          const record = event.target.result;
          if (record) {
            // 如果记录已存在，更新内容和更新时间
            record.reportContent = reportContent;
            record.updateTime = new Date().toISOString();
            const updateRequest = store.put(record);
            updateRequest.onsuccess = () => resolve(true); // 更新成功返回true
            updateRequest.onerror = () => resolve(false); // 更新失败返回false
          } else {
            // 如果记录不存在，新增记录
            const newRecord = {
              id,
              reportContent,
              updateTime: new Date().toISOString()
            };
            const addRequest = store.add(newRecord);
            addRequest.onsuccess = () => resolve(true); // 新增成功返回true
            addRequest.onerror = () => resolve(false); // 新增失败返回false
          }
        };

        request.onerror = () => resolve(false); // 获取记录失败返回false
      });
    };

    // 删除大于三天的记录
    const deleteReports = async () => {
      const db = await openDb();
      const transaction = db.transaction("reports", "readwrite");
      const store = transaction.objectStore("reports");
      const index = store.index("updateTime");
      const now = new Date();
      const threeDaysAgo = new Date(now.setDate(now.getDate() - 3)).toISOString();
      const range = IDBKeyRange.upperBound(threeDaysAgo);
      const request = index.openCursor(range);
      return new Promise((resolve, reject) => {
        request.onsuccess = event => {
          const cursor = event.target.result;
          if (cursor) {
            const record = cursor.value;
            const deleteRequest = store.delete(record.id);
            deleteRequest.onsuccess = () => {
              console.log(`Record with ID ${record.id} deleted`);
              cursor.continue();
            };
            deleteRequest.onerror = () => resolve(false); // 删除失败返回false
          } else {
            resolve(true); // 没有记录符合条件，返回true
          }
        };

        request.onerror = () => resolve(false); // 获取记录失败返回false
      });
    };

    // 删除指定id的记录
    const deleteReportById = async id => {
      const db = await openDb();
      const transaction = db.transaction("reports", "readwrite");
      const store = transaction.objectStore("reports");
      const request = store.get(id);
      return new Promise((resolve, reject) => {
        request.onsuccess = event => {
          const record = event.target.result;
          if (record) {
            const deleteRequest = store.delete(id);
            deleteRequest.onsuccess = () => resolve(true); // 删除成功返回true
            deleteRequest.onerror = () => resolve(false); // 删除失败返回false
          } else {
            resolve(false); // 如果记录不存在，返回false
          }
        };

        request.onerror = () => resolve(false); // 获取记录失败返回false
      });
    };

    // 根据id返回reportContent内容
    const getReportContent = async id => {
      const db = await openDb();
      const transaction = db.transaction("reports", "readonly");
      const store = transaction.objectStore("reports");
      const request = store.get(id);
      return new Promise((resolve, reject) => {
        request.onsuccess = event => {
          const record = event.target.result;
          if (record) {
            resolve(record.reportContent); // 返回报告内容
          } else {
            resolve(null); // 如果没有找到记录，返回null
          }
        };

        request.onerror = err => reject(`Error retrieving record: ${err.target.error}`);
      });
    };
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_input = _resolveComponent("a-input");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_image = _resolveComponent("a-image");
      const _component_a_upload = _resolveComponent("a-upload");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_input_search = _resolveComponent("a-input-search");
      const _component_vxe_column = _resolveComponent("vxe-column");
      const _component_a_menu_item = _resolveComponent("a-menu-item");
      const _component_a_menu = _resolveComponent("a-menu");
      const _component_a_dropdown = _resolveComponent("a-dropdown");
      const _component_vxe_table = _resolveComponent("vxe-table");
      const _component_a_config_provider = _resolveComponent("a-config-provider");
      const _component_vxe_pager = _resolveComponent("vxe-pager");
      const _component_a_tabs = _resolveComponent("a-tabs");
      const _component_a_divider = _resolveComponent("a-divider");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_col = _resolveComponent("a-col");
      const _component_a_date_picker = _resolveComponent("a-date-picker");
      const _component_a_row = _resolveComponent("a-row");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      const _component_a_space = _resolveComponent("a-space");
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      const _component_a_range_picker = _resolveComponent("a-range-picker");
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_el_button = _resolveComponent("el-button");
      const _component_ex_dialog = _resolveComponent("ex-dialog");
      const _component_a_radio = _resolveComponent("a-radio");
      const _component_a_radio_group = _resolveComponent("a-radio-group");
      const _directive_tinymce = _resolveDirective("tinymce");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_config_provider, {
        theme: {
          components: {
            Tabs: {
              fontSize: 18,
              colorPrimary: '#777777',
              colorText: '#C4C4C4',
              motionDurationMid: 0,
              motionDurationSlow: 0
            }
          }
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(interactionsStats.data.activityStatsTypeName) + " - " + _toDisplayString(interactionsStats.data.activityStatsItemName), 1), interactionsStats.data.vendorName ? (_openBlock(), _createElementBlock("div", _hoisted_5, " by " + _toDisplayString(interactionsStats.data.vendorName), 1)) : _createCommentVNode("", true), _unref(permission).havePermission('互动数据', '编辑互动数据') ? (_openBlock(), _createBlock(_component_a_button, {
          key: 1,
          onClick: onEdit,
          class: "sts-button default",
          style: {
            "width": "83px",
            "height": "25px",
            "padding": "0",
            "margin-left": "20px"
          }
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        })) : _createCommentVNode("", true)]), _createVNode(_component_a_tabs, {
          class: "sts-tabs default",
          activeKey: activeTabsKey.value,
          "onUpdate:activeKey": _cache[6] || (_cache[6] = $event => activeTabsKey.value = $event),
          type: "card",
          animated: false
        }, {
          default: _withCtx(() => [_unref(permission).havePermission('互动数据', '查看数据报告') ? (_openBlock(), _createBlock(_component_a_tab_pane, {
            key: "1",
            tab: "Report"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [currentActivityReportItem.value != null ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Data range: ")) : _createCommentVNode("", true), currentActivityReportItem.value != null ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(currentActivityReportItem.value.activityReportBegin) + " 00:00:00 - " + _toDisplayString(currentActivityReportItem.value.activityReportEnd) + " 00:00:00 ", 1)) : _createCommentVNode("", true), _hoisted_11, _unref(permission).havePermission('互动数据', '保存范围报告') ? (_openBlock(), _createBlock(_component_a_button, {
              key: 2,
              disabled: currentActivityReportItem.value == null || currentActivityReportItem.value.activityReportItemId == 0,
              style: {
                "margin-left": "10px"
              },
              onClick: onEditContent,
              class: "sts-button blue"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(reportContentIsEdit.value == true ? "Cancel" : "Edit"), 1)]),
              _: 1
            }, 8, ["disabled"])) : _createCommentVNode("", true), _unref(permission).havePermission('互动数据', '保存范围报告') ? (_openBlock(), _createBlock(_component_a_button, {
              key: 3,
              disabled: currentActivityReportItem.value == null || currentActivityReportItem.value.activityReportItemId == 0 || reportContentSaveDisabled.value == true,
              style: {
                "margin-left": "10px"
              },
              onClick: onSaveContent,
              class: "sts-button green"
            }, {
              default: _withCtx(() => [_createTextVNode("Save")]),
              _: 1
            }, 8, ["disabled"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_hoisted_14, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                onClick: $event => onChangeReportItemDetail(item),
                key: index,
                style: {
                  "display": "flex",
                  "margin-top": "10px",
                  "font-size": "12px",
                  "align-items": "center"
                }
              }, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [item.edit !== true ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["history-link", {
                  active: item === currentActivityReportItem.value
                }])
              }, _toDisplayString(item.activityReportItemName), 3)) : _createCommentVNode("", true), item.edit === true ? (_openBlock(), _createBlock(_component_a_input, {
                key: 1,
                style: {
                  "height": "30px",
                  "padding": "3px",
                  "font-size": "12px",
                  "width": "158px"
                },
                value: item.activityReportItemName,
                "onUpdate:value": $event => item.activityReportItemName = $event
              }, null, 8, ["value", "onUpdate:value"])) : _createCommentVNode("", true), item.edit === true ? (_openBlock(), _createBlock(_component_a_button, {
                key: 2,
                shape: "circle",
                onClick: $event => onSaveReport(item),
                style: {
                  "width": "16px",
                  "height": "16px",
                  "padding": "0px",
                  "min-width": "unset",
                  "border": "0",
                  "margin-left": "10px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_unref(CheckOutlined), {
                  style: {
                    "font-size": "15px"
                  }
                })]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true), item.edit === true ? (_openBlock(), _createBlock(_component_a_button, {
                key: 3,
                shape: "circle",
                onClick: $event => onCancelReport(item),
                style: {
                  "width": "16px",
                  "height": "16px",
                  "padding": "0px",
                  "min-width": "unset",
                  "border": "0",
                  "margin-left": "10px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_unref(CloseOutlined), {
                  style: {
                    "font-size": "15px"
                  }
                })]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true), item.activityReportItemId !== 0 && item.edit !== true && _unref(permission).havePermission('互动数据', '保存范围报告') ? (_openBlock(), _createBlock(_component_a_button, {
                key: 4,
                shape: "circle",
                onClick: $event => onEditReport(item),
                style: {
                  "width": "16px",
                  "height": "16px",
                  "padding": "0px",
                  "min-width": "unset",
                  "border": "0",
                  "margin-left": "10px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_unref(EditOutlined), {
                  style: {
                    "font-size": "15px"
                  }
                })]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true), item.activityReportItemId !== 0 && item.edit !== true ? (_openBlock(), _createBlock(_component_a_button, {
                key: 5,
                shape: "circle",
                onClick: $event => onToCopyLink(item),
                style: {
                  "width": "16px",
                  "height": "16px",
                  "padding": "0px",
                  "min-width": "unset",
                  "border": "0",
                  "margin-left": "20px",
                  "margin-top": "3px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_svg_icon, {
                  iconName: "share",
                  iconColor: '#777777',
                  iconSize: "14px"
                })]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_18, _toDisplayString("Created by " + item.createTime), 1)])], 8, _hoisted_15);
            }), 128))]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createVNode(_component_a_button, {
              onClick: downloadReportItemDetail,
              class: "sts-button default",
              style: {
                "width": "90px",
                "height": "25px",
                "padding": "0",
                "margin-right": "10px"
              }
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_21, [_createVNode(_component_svg_icon, {
                style: {
                  "margin-top": "2px"
                },
                iconName: "Download",
                iconColor: '#4185d4',
                iconSize: "16px"
              }), _hoisted_22])]),
              _: 1
            })]), _createElementVNode("div", _hoisted_23, [_createVNode(_component_a_upload, {
              disabled: !_unref(permission).havePermission('互动数据', '保存范围报告'),
              accept: "image/png, image/jpeg, image/gif, image/jpg",
              ref_key: "uploadActivityCover",
              ref: uploadActivityCover,
              "show-upload-list": false,
              action: uploadActivityCoverData.signatureData.host,
              "before-upload": handleActivityCoverBeforeUpload,
              "on-success": handleActivityCoverOnSuccess,
              data: uploadActivityCoverData.data,
              ":custom-request": customRequest,
              "on-exceed": handleActivityCoverExceed,
              "on-change": handleActivityCoverOnChange,
              "max-count": 1,
              "file-list": uploadActivityCoverData.fileList
            }, {
              default: _withCtx(() => [uploadActivityCoverData.file.url === null ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_27)) : _createCommentVNode("", true), uploadActivityCoverData.file.url !== null ? (_openBlock(), _createBlock(_component_a_image, {
                key: 1,
                width: 200,
                height: 200,
                preview: false,
                style: {
                  "flex": "1",
                  "cursor": "pointer"
                },
                src: uploadActivityCoverData.file.url
              }, null, 8, ["src"])) : _createCommentVNode("", true)]),
              _: 1
            }, 8, ["disabled", "action", "data", "file-list"]), currentActivityReportItem.value != null ? (_openBlock(), _createElementBlock("div", _hoisted_28, [activityStatsItem.storeInfoListMap && activityStatsItem.storeInfoListMap.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_hoisted_30, _createElementVNode("div", _hoisted_31, [_hoisted_32, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityStatsItem.storeInfoListMap, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.city), 1);
            }), 128))]), _createElementVNode("div", _hoisted_33, [_hoisted_34, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityStatsItem.storeInfoListMap, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.storeName), 1);
            }), 128))]), _createElementVNode("div", _hoisted_35, [_hoisted_36, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityStatsItem.storeInfoListMap, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.playNumber), 1);
            }), 128))]), _createElementVNode("div", _hoisted_37, [_hoisted_38, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityStatsItem.storeInfoListMap, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.playNumberDistinct), 1);
            }), 128))]), _hoisted_39])) : _createCommentVNode("", true), activityStatsItem.cityRankListMap && activityStatsItem.cityRankListMap.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_hoisted_41, _createElementVNode("div", _hoisted_42, [_hoisted_43, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityStatsItem.cityRankListMap, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.city), 1);
            }), 128))]), _createElementVNode("div", _hoisted_44, [_hoisted_45, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityStatsItem.cityRankListMap, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.rankId), 1);
            }), 128))]), _createElementVNode("div", _hoisted_46, [_hoisted_47, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityStatsItem.cityRankListMap, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.cityNumber), 1);
            }), 128))]), _createElementVNode("div", _hoisted_48, [_hoisted_49, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityStatsItem.cityRankListMap, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.playNumber), 1);
            }), 128))]), _createElementVNode("div", _hoisted_50, [_hoisted_51, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityStatsItem.cityRankListMap, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.playNumberDistinct), 1);
            }), 128))]), _hoisted_52])) : _createCommentVNode("", true), _createElementVNode("div", {
              ref_key: "reportItemDetail",
              ref: reportItemDetail,
              style: {
                "display": "flex",
                "flex-shrink": "0",
                "flex-direction": "column",
                "overflow": "hidden",
                "width": "max-content"
              }
            }, [_createElementVNode("div", _hoisted_53, [_hoisted_54, _createElementVNode("div", _hoisted_55, _toDisplayString(interactionsStats.data.activityStatsItemName), 1)]), _createElementVNode("div", _hoisted_56, [_hoisted_57, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemDetailData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.storeName), 1);
            }), 128))]), _createElementVNode("div", _hoisted_58, [_hoisted_59, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemDetailData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.trackingDatesStart), 1);
            }), 128))]), _createElementVNode("div", _hoisted_60, [_hoisted_61, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemDetailData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.trackingDatesEnd), 1);
            }), 128))]), _createElementVNode("div", _hoisted_62, [_hoisted_63, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemDetailData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.periodDays === null ? 0 : item.periodDays), 1);
            }), 128))]), _createElementVNode("div", _hoisted_64, [_hoisted_65, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemDetailData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.vendorName), 1);
            }), 128))]), currentActivityReportItem.value.activityReportItemId !== 0 && _unref(tokenData).type === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_66, [_hoisted_67, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemDetailData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                style: {
                  "padding-right": "10px"
                }
              }, [!_unref(permission).havePermission('互动数据', '保存范围报告') ? (_openBlock(), _createElementBlock("div", _hoisted_68, _toDisplayString(item.actualSpending), 1)) : _createCommentVNode("", true), _unref(permission).havePermission('互动数据', '保存范围报告') ? (_openBlock(), _createBlock(_component_a_input, {
                key: 1,
                style: {
                  "height": "26px",
                  "padding": "3px",
                  "font-size": "12px"
                },
                value: activityReportItemDetailData[index].actualSpending,
                "onUpdate:value": $event => activityReportItemDetailData[index].actualSpending = $event
              }, {
                suffix: _withCtx(() => [activityReportItemDetailData[index].actualSpending !== activityReportItemDetailData[index].actualSpending_ ? (_openBlock(), _createBlock(_component_a_tooltip, {
                  key: 0,
                  title: "Save"
                }, {
                  default: _withCtx(() => [_createVNode(_unref(CheckOutlined), {
                    onClick: $event => onSaveActualSpending(currentActivityReportItem.value.activityReportItemId, activityReportItemDetailData[index]),
                    style: {
                      "color": "rgba(0, 0, 0, 0.45)"
                    }
                  }, null, 8, ["onClick"])]),
                  _: 2
                }, 1024)) : _createCommentVNode("", true)]),
                _: 2
              }, 1032, ["value", "onUpdate:value"])) : _createCommentVNode("", true)]);
            }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_69, [_hoisted_70, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemDetailData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.total === null ? 0 : item.total), 1);
            }), 128))]), _hoisted_71, _createElementVNode("div", _hoisted_72, [_hoisted_73, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemDetailData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.busiestDayWeek), 1);
            }), 128))]), _createElementVNode("div", _hoisted_74, [_hoisted_75, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemDetailData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                style: {
                  "background-color": "rgba(23, 185, 149, 0.15)"
                }
              }, _toDisplayString(item.busiestDay), 1);
            }), 128))]), _createElementVNode("div", _hoisted_76, [_hoisted_77, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemDetailData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.interactionsBusiestDay === null ? 0 : item.interactionsBusiestDay), 1);
            }), 128))]), _createElementVNode("div", _hoisted_78, [_hoisted_79, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemDetailData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.slowestDayWeek), 1);
            }), 128))]), _createElementVNode("div", _hoisted_80, [_hoisted_81, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemDetailData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                style: {
                  "background-color": "rgba(255, 63, 34, 0.15)"
                }
              }, _toDisplayString(item.slowestDay), 1);
            }), 128))]), _createElementVNode("div", _hoisted_82, [_hoisted_83, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemDetailData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.interactionsSlowestDay === null ? 0 : item.interactionsSlowestDay), 1);
            }), 128))]), _hoisted_84, _createElementVNode("div", _hoisted_85, [_hoisted_86, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemDetailData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, " Interactions/day ");
            }), 128))]), _createElementVNode("div", _hoisted_87, [_hoisted_88, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemDetailData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.sunday === null ? 0 : item.sunday), 1);
            }), 128))]), _createElementVNode("div", _hoisted_89, [_hoisted_90, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemDetailData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.monday === null ? 0 : item.monday), 1);
            }), 128))]), _createElementVNode("div", _hoisted_91, [_hoisted_92, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemDetailData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.tuesday === null ? 0 : item.tuesday), 1);
            }), 128))]), _createElementVNode("div", _hoisted_93, [_hoisted_94, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemDetailData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.wednesday === null ? 0 : item.wednesday), 1);
            }), 128))]), _createElementVNode("div", _hoisted_95, [_hoisted_96, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemDetailData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.thursday === null ? 0 : item.thursday), 1);
            }), 128))]), _createElementVNode("div", _hoisted_97, [_hoisted_98, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemDetailData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.friday === null ? 0 : item.friday), 1);
            }), 128))]), _createElementVNode("div", _hoisted_99, [_hoisted_100, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemDetailData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.saturday === null ? 0 : item.saturday), 1);
            }), 128))]), _hoisted_101, _createElementVNode("div", _hoisted_102, [_hoisted_103, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemDetailData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.storeName), 1);
            }), 128))]), activityReportItemDetailData && activityReportItemDetailData.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
              key: 1
            }, _renderList(activityReportItemDetailData[0].reportItemMonthCounts.length, index => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                class: "report-item-row"
              }, [_createElementVNode("div", null, _toDisplayString(activityReportItemDetailData[0].reportItemMonthCounts[index - 1].yearMonth), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemDetailData, (item, index1) => {
                return _openBlock(), _createElementBlock("div", {
                  key: index1
                }, _toDisplayString(item.reportItemMonthCounts[index - 1].count), 1);
              }), 128))]);
            }), 128)) : _createCommentVNode("", true), _hoisted_104, _createElementVNode("div", _hoisted_105, [_hoisted_106, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemDetailData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, _toDisplayString(item.storeName), 1);
            }), 128))]), activityReportItemDetailData && activityReportItemDetailData.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
              key: 2
            }, _renderList(activityReportItemDetailData[0].reportItemDateCounts.length, index => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                class: "report-item-row"
              }, [_createElementVNode("div", null, _toDisplayString(activityReportItemDetailData[0].reportItemDateCounts[index - 1].weekDateName), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityReportItemDetailData, (item, index1) => {
                return _openBlock(), _createElementBlock("div", {
                  key: index1
                }, _toDisplayString(item.reportItemDateCounts[index - 1].count), 1);
              }), 128))]);
            }), 128)) : _createCommentVNode("", true)], 512)])) : _createCommentVNode("", true)])]), _createElementVNode("div", {
              style: _normalizeStyle([{
                top: reportContentIsEdit.value === false ? '-10000px' : 'auto',
                position: reportContentIsEdit.value === false ? 'absolute' : 'static'
              }, {
                "display": "flex",
                "flex": "1"
              }])
            }, [_withDirectives(_createElementVNode("textarea", null, null, 512), [[_directive_tinymce, reportContent.value]])], 4), _withDirectives(_createElementVNode("iframe", {
              style: {
                "flex": "1",
                "border": "1px solid #d7d4d4"
              },
              ref_key: "reportContentRef",
              ref: reportContentRef
            }, null, 512), [[_vShow, reportContentIsEdit.value == false]])])])]),
            _: 1
          })) : _createCommentVNode("", true), _unref(permission).havePermission('互动数据', '查看数据摘要') && currentStatsItemUserType.value !== 1 ? (_openBlock(), _createBlock(_component_a_tab_pane, {
            key: "2",
            tab: "Data"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_107, [_createElementVNode("div", _hoisted_108, [_createElementVNode("div", _hoisted_109, [_createElementVNode("div", _hoisted_110, [_hoisted_111, _createElementVNode("div", _hoisted_112, _toDisplayString(interactionsStats.data.totalDays), 1)]), _createElementVNode("div", _hoisted_113, [_hoisted_114, _createElementVNode("div", _hoisted_115, _toDisplayString(interactionsStats.data.totalInteractions), 1)]), _createElementVNode("div", _hoisted_116, [_hoisted_117, _createElementVNode("div", _hoisted_118, _toDisplayString(interactionsStats.data.dailyAverageInteractions), 1)]), _createElementVNode("div", _hoisted_119, [_hoisted_120, _createElementVNode("div", _hoisted_121, [_createElementVNode("div", _hoisted_122, [_hoisted_123, _createElementVNode("div", _hoisted_124, _toDisplayString(interactionsStats.data.sunday), 1)]), _createElementVNode("div", _hoisted_125, [_hoisted_126, _createElementVNode("div", _hoisted_127, _toDisplayString(interactionsStats.data.monday), 1)]), _createElementVNode("div", _hoisted_128, [_hoisted_129, _createElementVNode("div", _hoisted_130, _toDisplayString(interactionsStats.data.tuesday), 1)]), _createElementVNode("div", _hoisted_131, [_hoisted_132, _createElementVNode("div", _hoisted_133, _toDisplayString(interactionsStats.data.wednesday), 1)]), _createElementVNode("div", _hoisted_134, [_hoisted_135, _createElementVNode("div", _hoisted_136, _toDisplayString(interactionsStats.data.thursday), 1)]), _createElementVNode("div", _hoisted_137, [_hoisted_138, _createElementVNode("div", _hoisted_139, _toDisplayString(interactionsStats.data.friday), 1)]), _createElementVNode("div", _hoisted_140, [_hoisted_141, _createElementVNode("div", _hoisted_142, _toDisplayString(interactionsStats.data.saturday), 1)])])]), _createElementVNode("div", _hoisted_143, [_createVNode(_component_a_button, {
              onClick: downloadReportItemDetail,
              class: "sts-button default",
              style: {
                "width": "120px",
                "height": "25px",
                "padding": "0"
              }
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_144, [_createVNode(_component_svg_icon, {
                style: {
                  "margin-top": "2px"
                },
                iconName: "Download",
                iconColor: '#4185d4',
                iconSize: "16px"
              }), _hoisted_145])]),
              _: 1
            }), _createVNode(_component_a_button, {
              onClick: onGroupAggFilter,
              class: "sts-button default",
              style: {
                "width": "120px",
                "height": "25px",
                "margin-top": "15px",
                "padding": "0"
              }
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_146, [_createVNode(_component_svg_icon, {
                style: {
                  "margin-top": "2px"
                },
                iconName: "filter",
                iconColor: '#4185d4',
                iconSize: "16px"
              }), _hoisted_147])]),
              _: 1
            })])]), columnOptions.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_148, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activitySummaryItemData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                class: "summary-card"
              }, [_unref(permission).havePermission('互动数据', '新增数据摘要') ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                shape: "circle",
                onClick: $event => onSummaryEdit(item),
                style: {
                  "width": "16px",
                  "height": "16px",
                  "padding": "0px",
                  "min-width": "unset",
                  "border": "0",
                  "position": "absolute",
                  "left": "5px",
                  "top": "5px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_svg_icon, {
                  iconName: "setup",
                  iconColor: '#777777',
                  iconSize: "14px"
                })]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true), _unref(permission).havePermission('互动数据', '新增数据摘要') ? (_openBlock(), _createBlock(_component_a_button, {
                key: 1,
                shape: "circle",
                onClick: $event => removeActivitySummaryItem(item),
                style: {
                  "width": "16px",
                  "height": "16px",
                  "padding": "0px",
                  "min-width": "unset",
                  "border": "0",
                  "position": "absolute",
                  "right": "5px",
                  "top": "5px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_svg_icon, {
                  iconName: "close_circle",
                  iconColor: '#777777',
                  iconSize: "14px"
                })]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_149, _toDisplayString(item.summaryTitle), 1), _createElementVNode("div", _hoisted_150, _toDisplayString(item.summaryValue), 1)]);
            }), 128)), _unref(permission).havePermission('互动数据', '新增数据摘要') ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "summary-add-card",
              onClick: onAddSummary
            }, _hoisted_153)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _hoisted_154, _createVNode(_component_a_tabs, {
              class: "sts-tabs default",
              activeKey: dataTabsKey.value,
              "onUpdate:activeKey": _cache[5] || (_cache[5] = $event => dataTabsKey.value = $event),
              type: "card",
              animated: false,
              onChange: activeTabsKeyChange
            }, {
              default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
                key: "1",
                tab: "Detail"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_155, [_createElementVNode("div", _hoisted_156, [_hoisted_157, _createElementVNode("div", _hoisted_158, _toDisplayString(interactionsStats.data.activityStatsBegin) + " 00:00:00 - " + _toDisplayString(interactionsStats.data.endCurrentTime), 1), _hoisted_159, _createVNode(_component_a_input_search, {
                  value: activityStatsItem.searchKeyword,
                  "onUpdate:value": _cache[0] || (_cache[0] = $event => activityStatsItem.searchKeyword = $event),
                  placeholder: "input search text",
                  style: {
                    "width": "200px"
                  },
                  onSearch: onStatsItemSearch
                }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_160, [_createElementVNode("div", _hoisted_161, [_createVNode(_component_a_config_provider, {
                  theme: {
                    components: {
                      Button: {
                        controlHeight: 24
                      }
                    }
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_vxe_table, {
                    stripe: "",
                    height: "auto",
                    data: activityStatsItem.data,
                    ref_key: "activityStatsItemTable",
                    ref: activityStatsItemTable,
                    class: "sts-table",
                    "show-overflow": "",
                    border: 'none'
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityColumnData.filter(column => column.title !== '原始报告' && column.title !== '完整报告' && column.title !== '分享报告' && column.title !== '姓名' && column.title !== '性别' && column.title !== '年龄' && column.title !== '体重' && column.title !== '身高'), (column, index) => {
                      return _openBlock(), _createBlock(_component_vxe_column, {
                        key: index,
                        field: column.name,
                        title: column.title,
                        "min-width": column.width
                      }, null, 8, ["field", "title", "min-width"]);
                    }), 128)), _createVNode(_component_vxe_column, {
                      width: "100",
                      fixed: "right",
                      title: "action"
                    }, {
                      default: _withCtx(({
                        row
                      }) => [_createVNode(_component_a_dropdown, {
                        trigger: ['click']
                      }, {
                        overlay: _withCtx(() => [_createVNode(_component_a_menu, null, {
                          default: _withCtx(() => [_unref(itemId) !== '104' ? (_openBlock(), _createBlock(_component_a_menu_item, {
                            key: "0",
                            onClick: $event => editActivityStatsItem(row)
                          }, {
                            default: _withCtx(() => [_hoisted_162]),
                            _: 2
                          }, 1032, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_a_menu_item, {
                            key: "1",
                            onClick: $event => removeActivityStatsItem(row)
                          }, {
                            default: _withCtx(() => [_hoisted_163]),
                            _: 2
                          }, 1032, ["onClick"])]),
                          _: 2
                        }, 1024)]),
                        default: _withCtx(() => [_createVNode(_component_a_button, {
                          class: "sts-button-circle-icon default",
                          shape: "circle"
                        }, {
                          default: _withCtx(() => [_createVNode(_component_svg_icon, {
                            iconName: "more",
                            iconColor: '#777777',
                            iconSize: "16px"
                          })]),
                          _: 1
                        })]),
                        _: 2
                      }, 1024)]),
                      _: 1
                    })]),
                    _: 1
                  }, 8, ["data"])]),
                  _: 1
                })]), _createElementVNode("div", _hoisted_164, [_createVNode(_component_vxe_pager, {
                  class: "sts-pager",
                  background: "",
                  "page-size": activityStatsItemPagination.pageSize,
                  "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => activityStatsItemPagination.pageSize = $event),
                  "current-page": activityStatsItemPagination.currentPage,
                  "onUpdate:currentPage": _cache[2] || (_cache[2] = $event => activityStatsItemPagination.currentPage = $event),
                  "pager-count": 5,
                  total: activityStatsItemPagination.totalSize,
                  layouts: ['PrevJump', 'JumpNumber', 'NextJump', 'Sizes', 'FullJump', 'Total'],
                  onPageChange: paginationCurrentActivityStatsItemChange
                }, null, 8, ["page-size", "current-page", "total", "onPageChange"])])])])]),
                _: 1
              }), _createVNode(_component_a_tab_pane, {
                key: "2"
              }, {
                tab: _withCtx(() => [_createElementVNode("div", _hoisted_165, [_hoisted_166, _unref(permission).havePermission('互动数据', '设置数据总结') ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  shape: "circle",
                  onClick: onGroupAggEdit,
                  style: {
                    "width": "16px",
                    "height": "16px",
                    "padding": "0px",
                    "min-width": "unset",
                    "border": "0",
                    "margin-left": "10px"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_svg_icon, {
                    iconName: "setup",
                    iconColor: '#777777',
                    iconSize: "14px"
                  })]),
                  _: 1
                })) : _createCommentVNode("", true)])]),
                default: _withCtx(() => [_createElementVNode("div", _hoisted_167, [_createElementVNode("div", _hoisted_168, [_createElementVNode("div", _hoisted_169, [_createVNode(_component_a_config_provider, {
                  theme: {
                    components: {
                      Button: {
                        controlHeight: 24
                      }
                    }
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_vxe_table, {
                    stripe: "",
                    height: "auto",
                    data: activityItemGroupAggData,
                    ref_key: "activityStatsItemGroupAggTable",
                    ref: activityStatsItemGroupAggTable,
                    class: "sts-table",
                    "show-overflow": "",
                    border: 'none'
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityItemGroupAggColumnData, (column, index) => {
                      return _openBlock(), _createBlock(_component_vxe_column, {
                        key: index,
                        field: column.name,
                        title: column.title,
                        "min-width": column.width
                      }, null, 8, ["field", "title", "min-width"]);
                    }), 128))]),
                    _: 1
                  }, 8, ["data"])]),
                  _: 1
                })]), _createElementVNode("div", _hoisted_170, [_createVNode(_component_vxe_pager, {
                  class: "sts-pager",
                  background: "",
                  "page-size": activityItemGroupAggPagination.pageSize,
                  "onUpdate:pageSize": _cache[3] || (_cache[3] = $event => activityItemGroupAggPagination.pageSize = $event),
                  "current-page": activityItemGroupAggPagination.currentPage,
                  "onUpdate:currentPage": _cache[4] || (_cache[4] = $event => activityItemGroupAggPagination.currentPage = $event),
                  "pager-count": 5,
                  total: activityItemGroupAggPagination.totalSize,
                  layouts: ['PrevJump', 'JumpNumber', 'NextJump', 'Sizes', 'FullJump', 'Total'],
                  onPageChange: paginationCurrentActivityItemGroupAggChange
                }, null, 8, ["page-size", "current-page", "total", "onPageChange"])])])])]),
                _: 1
              })]),
              _: 1
            }, 8, ["activeKey"])])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["activeKey"])]),
        _: 1
      })])]), _createVNode(_component_a_modal, {
        open: activityStatsItemOpen.value,
        "onUpdate:open": _cache[8] || (_cache[8] = $event => activityStatsItemOpen.value = $event),
        closable: false,
        zIndex: 1001,
        centered: true
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_171, [_hoisted_172, _createVNode(_component_a_divider, {
          style: {
            "margin": "10px 30px 10px 20px",
            "min-width": "0px"
          }
        })])]),
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_173, [_createVNode(_component_a_divider, {
          style: {
            "margin": "10px 30px 10px 0px",
            "min-width": "0px"
          }
        }), _createVNode(_component_a_button, {
          class: "sts-button default",
          key: "back",
          onClick: onActivityStatsItemCancel
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_a_button, {
          class: "sts-button green",
          key: "submit",
          type: "primary",
          loading: _ctx.loading,
          onClick: onActivityStatsItemSave
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_a_form, {
          model: activityStatsItemEditFormData.value,
          ref_key: "activityStatsItemEditForm",
          ref: activityStatsItemEditForm,
          class: "sts-form",
          "label-col": {
            span: 8
          },
          "label-align": "left",
          autocomplete: "off",
          rules: _ctx.activityColumnValidRules
        }, {
          default: _withCtx(() => [_createVNode(_component_a_row, null, {
            default: _withCtx(() => [_createVNode(_component_a_col, null, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: '店铺名称:',
                name: 'store_code',
                rules: [{
                  required: true,
                  message: '请选择店铺名称'
                }],
                style: {
                  "width": "450px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_a_select, {
                  "show-search": "",
                  dropdownMatchSelectWidth: false,
                  options: storeOptions,
                  popupClassName: "sts-select-dropdown",
                  value: activityStatsItemEditFormData.value['store_code'],
                  "onUpdate:value": _cache[7] || (_cache[7] = $event => activityStatsItemEditFormData.value['store_code'] = $event),
                  "filter-option": filterStoreOption
                }, {
                  suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                    class: "ant-select-suffix"
                  })]),
                  _: 1
                }, 8, ["options", "value"])]),
                _: 1
              })]),
              _: 1
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityColumnData.filter(column => column.name !== 'store_name' && column.name !== 'store_code'), (column, index) => {
              return _openBlock(), _createBlock(_component_a_col, {
                key: index,
                span: 16
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  label: column.title + ':',
                  name: column.name,
                  rules: column.required === true ? [{
                    required: true,
                    message: '请输入' + column.title
                  }] : [],
                  style: {
                    "width": "450px"
                  }
                }, {
                  default: _withCtx(() => [column.type === 'datetime' ? (_openBlock(), _createBlock(_component_a_date_picker, {
                    key: 0,
                    class: "sts-picker",
                    popupClassName: "sts-picker",
                    value: activityStatsItemEditFormData.value[column.name],
                    "onUpdate:value": $event => activityStatsItemEditFormData.value[column.name] = $event,
                    format: "YYYY-MM-DD HH:mm:ss",
                    "show-time": {
                      defaultValue: _unref(dayjs)('00:00:00', 'HH:mm:ss')
                    },
                    style: {
                      "width": "100%"
                    }
                  }, null, 8, ["value", "onUpdate:value", "show-time"])) : column.type === 'date' ? (_openBlock(), _createBlock(_component_a_date_picker, {
                    key: 1,
                    class: "sts-picker",
                    popupClassName: "sts-picker",
                    value: activityStatsItemEditFormData.value[column.name],
                    "onUpdate:value": $event => activityStatsItemEditFormData.value[column.name] = $event,
                    style: {
                      "width": "100%"
                    }
                  }, null, 8, ["value", "onUpdate:value"])) : (_openBlock(), _createBlock(_component_a_input, {
                    key: 2,
                    value: activityStatsItemEditFormData.value[column.name],
                    "onUpdate:value": $event => activityStatsItemEditFormData.value[column.name] = $event,
                    style: {
                      "width": "100%"
                    }
                  }, null, 8, ["value", "onUpdate:value"]))]),
                  _: 2
                }, 1032, ["label", "name", "rules"])]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["open"]), _createVNode(_component_a_modal, {
        open: addSummaryOpen.value,
        "onUpdate:open": _cache[16] || (_cache[16] = $event => addSummaryOpen.value = $event),
        closable: false,
        zIndex: 1001,
        centered: true,
        width: "650px"
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_174, [_hoisted_175, _createVNode(_component_a_divider, {
          style: {
            "margin": "10px 30px 10px 20px",
            "min-width": "0px",
            "flex": "1"
          }
        })])]),
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_188, [_createVNode(_component_a_divider, {
          style: {
            "margin": "10px 30px 10px 0px",
            "min-width": "0px"
          }
        }), _createVNode(_component_a_button, {
          class: "sts-button default",
          key: "back",
          onClick: onAddSummaryCancel
        }, {
          default: _withCtx(() => [_createTextVNode("Cancel")]),
          _: 1
        }), _createVNode(_component_a_button, {
          class: "sts-button green",
          key: "submit",
          type: "primary",
          loading: _ctx.loading,
          onClick: onAddSummarySave
        }, {
          default: _withCtx(() => [_createTextVNode("Save")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_176, [_createElementVNode("div", _hoisted_177, [_hoisted_178, _createElementVNode("div", null, [_createVNode(_component_a_input, {
          status: summaryValidMessage.summaryTitleError != null ? 'error' : null,
          value: summaryFormData.summaryTitle,
          "onUpdate:value": _cache[9] || (_cache[9] = $event => summaryFormData.summaryTitle = $event),
          style: {
            "width": "488px",
            "margin-left": "20px"
          }
        }, null, 8, ["status", "value"])])]), _createElementVNode("div", _hoisted_179, [summaryValidMessage.summaryTitleError != null ? (_openBlock(), _createElementBlock("span", _hoisted_180, _toDisplayString(summaryValidMessage.summaryTitleError), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_181, [_hoisted_182, _createElementVNode("div", null, [_createVNode(_component_a_select, {
          status: summaryValidMessage.fieldNameError != null ? 'error' : null,
          dropdownMatchSelectWidth: false,
          options: columnOptions.value,
          popupClassName: "sts-select-dropdown",
          value: summaryFormData.fieldName,
          "onUpdate:value": _cache[10] || (_cache[10] = $event => summaryFormData.fieldName = $event),
          style: {
            "width": "488px",
            "margin-left": "20px"
          }
        }, {
          suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
            class: "ant-select-suffix"
          })]),
          _: 1
        }, 8, ["status", "options", "value"])])]), _createElementVNode("div", _hoisted_183, [summaryValidMessage.fieldNameError != null ? (_openBlock(), _createElementBlock("span", _hoisted_184, _toDisplayString(summaryValidMessage.fieldNameError), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_185, [_hoisted_186, _createElementVNode("div", _hoisted_187, [_createVNode(_component_a_space, null, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: _normalizeClass([{
              active: summaryFormData.shownId === 1
            }, "filter-button"]),
            onClick: _cache[11] || (_cache[11] = $event => onShownChange(1))
          }, " Highest ", 2), _createElementVNode("div", {
            class: _normalizeClass([{
              active: summaryFormData.shownId === 2
            }, "filter-button"]),
            onClick: _cache[12] || (_cache[12] = $event => onShownChange(2))
          }, " Lowest ", 2), _createElementVNode("div", {
            class: _normalizeClass([{
              active: summaryFormData.shownId === 3
            }, "filter-button"]),
            onClick: _cache[13] || (_cache[13] = $event => onShownChange(3))
          }, " Average ", 2), _createElementVNode("div", {
            class: _normalizeClass([{
              active: summaryFormData.shownId === 4
            }, "filter-button"]),
            onClick: _cache[14] || (_cache[14] = $event => onShownChange(4))
          }, " Sum ", 2), _createElementVNode("div", {
            class: _normalizeClass([{
              active: summaryFormData.shownId === 5
            }, "filter-button"]),
            onClick: _cache[15] || (_cache[15] = $event => onShownChange(5))
          }, " Count ", 2)]),
          _: 1
        })])])])]),
        _: 1
      }, 8, ["open"]), _createVNode(_component_a_modal, {
        open: addReportOpen.value,
        "onUpdate:open": _cache[26] || (_cache[26] = $event => addReportOpen.value = $event),
        closable: false,
        width: "900px",
        zIndex: 1001,
        centered: true
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_189, [_hoisted_190, _createVNode(_component_a_divider, {
          style: {
            "margin": "10px 30px 10px 20px",
            "min-width": "0px",
            "flex": "1"
          }
        })])]),
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_205, [_createVNode(_component_a_divider, {
          style: {
            "margin": "10px 30px 10px 0px",
            "min-width": "0px"
          }
        }), _createVNode(_component_a_button, {
          class: "sts-button default",
          key: "back",
          onClick: onReportItemCancel
        }, {
          default: _withCtx(() => [_createTextVNode("Cancel")]),
          _: 1
        }), _createVNode(_component_a_button, {
          class: "sts-button green",
          key: "submit",
          type: "primary",
          loading: _ctx.loading,
          onClick: onReportItemSave
        }, {
          default: _withCtx(() => [_createTextVNode("Create")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_191, [_createElementVNode("div", _hoisted_192, [_hoisted_193, _createElementVNode("div", _hoisted_194, [_createVNode(_component_a_space, {
          size: "large"
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: _normalizeClass([{
              active: reportFormData.dateFastId === 1
            }, "filter-button"]),
            onClick: _cache[17] || (_cache[17] = $event => onDateFastChange(1))
          }, " All ", 2), _createElementVNode("div", {
            class: _normalizeClass([{
              active: reportFormData.dateFastId === 2
            }, "filter-button"]),
            onClick: _cache[18] || (_cache[18] = $event => onDateFastChange(2))
          }, " This Week ", 2), _createElementVNode("div", {
            class: _normalizeClass([{
              active: reportFormData.dateFastId === 3
            }, "filter-button"]),
            onClick: _cache[19] || (_cache[19] = $event => onDateFastChange(3))
          }, " Last Week ", 2), _createElementVNode("div", {
            class: _normalizeClass([{
              active: reportFormData.dateFastId === 4
            }, "filter-button"]),
            onClick: _cache[20] || (_cache[20] = $event => onDateFastChange(4))
          }, " This Month ", 2), _createElementVNode("div", {
            class: _normalizeClass([{
              active: reportFormData.dateFastId === 5
            }, "filter-button"]),
            onClick: _cache[21] || (_cache[21] = $event => onDateFastChange(5))
          }, " Last Month ", 2)]),
          _: 1
        })])]), _hoisted_195, _createElementVNode("div", _hoisted_196, [_hoisted_197, _createVNode(_component_a_checkbox, {
          style: {
            "margin-left": "20px"
          },
          checked: reportFormData.activityCycle,
          "onUpdate:checked": _cache[22] || (_cache[22] = $event => reportFormData.activityCycle = $event)
        }, null, 8, ["checked"]), reportFormData.activityCycle !== true ? (_openBlock(), _createElementBlock("div", _hoisted_198, " Custom Range: ")) : _createCommentVNode("", true), reportFormData.activityCycle !== true ? (_openBlock(), _createBlock(_component_a_config_provider, {
          key: 1,
          theme: {
            components: {
              DatePicker: {
                controlHeight: 25
              }
            },
            token: {
              borderRadius: 4
            }
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_a_range_picker, {
            status: reportValidMessage.dateRangeError != null ? 'error' : null,
            popupClassName: "sts-picker",
            value: reportFormData.dateRange,
            "onUpdate:value": _cache[23] || (_cache[23] = $event => reportFormData.dateRange = $event)
          }, {
            suffixIcon: _withCtx(() => []),
            _: 1
          }, 8, ["status", "value"])]),
          _: 1
        })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_199, [reportValidMessage.dateRangeError != null ? (_openBlock(), _createElementBlock("span", _hoisted_200, _toDisplayString(reportValidMessage.dateRangeError), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_201, [_hoisted_202, _createElementVNode("div", null, [_createVNode(_component_a_select, {
          allowClear: "",
          dropdownMatchSelectWidth: false,
          options: filterStoreTypeData,
          fieldNames: {
            label: 'storeTypeNameZh',
            value: 'storeTypeId'
          },
          popupClassName: "sts-select-dropdown",
          value: reportFormData.storeTypeId,
          "onUpdate:value": _cache[24] || (_cache[24] = $event => reportFormData.storeTypeId = $event),
          style: {
            "width": "250px",
            "margin-left": "20px"
          },
          onChange: onStoreTypeChange
        }, {
          suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
            class: "ant-select-suffix"
          })]),
          _: 1
        }, 8, ["options", "value"])]), _createElementVNode("div", null, [_createVNode(_component_a_select, {
          dropdownMatchSelectWidth: false,
          showSearch: true,
          mode: "multiple",
          options: filterStoreData,
          popupClassName: "sts-select-dropdown",
          value: reportFormData.storeCodes,
          "onUpdate:value": _cache[25] || (_cache[25] = $event => reportFormData.storeCodes = $event),
          style: {
            "max-width": "620px",
            "min-width": "250px",
            "margin-left": "20px"
          },
          showArrow: true,
          "filter-option": filterStoreOption
        }, {
          suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
            class: "ant-select-suffix"
          })]),
          _: 1
        }, 8, ["options", "value"])])]), _createElementVNode("div", _hoisted_203, [reportValidMessage.storeCodeError != null ? (_openBlock(), _createElementBlock("span", _hoisted_204, _toDisplayString(reportValidMessage.storeCodeError), 1)) : _createCommentVNode("", true)])])]),
        _: 1
      }, 8, ["open"]), _createVNode(_component_ex_dialog, {
        extraStyle: "min-width: 380px; max-width: 808px;width: 80%",
        isVisible: activityCoverDialogVisible.value
      }, {
        default: _withCtx(() => [_hoisted_206, _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_207, [_createVNode(_unref(VueCropper), {
          ref_key: "coverCropper",
          ref: coverCropper,
          img: activityCoverCropper.img,
          "output-size": activityCoverCropper.size,
          "output-type": activityCoverCropper.outputType,
          info: true,
          "info-true": true,
          full: activityCoverCropper.full,
          fixed: activityCoverCropper.fixed,
          "fixed-number": activityCoverCropper.fixedNumber,
          "can-move": activityCoverCropper.canMove,
          "can-move-box": activityCoverCropper.canMoveBox,
          "fixed-box": activityCoverCropper.fixedBox,
          original: activityCoverCropper.original,
          "auto-crop": activityCoverCropper.autoCrop,
          "auto-crop-width": activityCoverCropper.autoCropWidth,
          "auto-crop-height": activityCoverCropper.autoCropHeight,
          "center-box": activityCoverCropper.centerBox,
          onRealTime: realTime,
          high: activityCoverCropper.high,
          mode: "contain",
          "max-img-size": activityCoverCropper.max,
          "limit-min-size": activityCoverCropper.limitMinSize
        }, null, 8, ["img", "output-size", "output-type", "full", "fixed", "fixed-number", "can-move", "can-move-box", "fixed-box", "original", "auto-crop", "auto-crop-width", "auto-crop-height", "center-box", "high", "max-img-size", "limit-min-size"])]), _createElementVNode("div", _hoisted_208, [_createVNode(_component_el_button, {
          onClick: getCoverCropBlobClick,
          class: "button-default wide",
          color: "black"
        }, {
          default: _withCtx(() => [_hoisted_209]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: _cache[27] || (_cache[27] = $event => activityCoverDialogVisible.value = false),
          style: {
            "border-color": "black",
            "color": "black"
          },
          class: "button-default wide"
        }, {
          default: _withCtx(() => [_hoisted_210]),
          _: 1
        })])]),
        _: 1
      }, 8, ["isVisible"]), _createVNode(_component_a_modal, {
        open: updateGroupAggOpen.value,
        "onUpdate:open": _cache[29] || (_cache[29] = $event => updateGroupAggOpen.value = $event),
        closable: false,
        width: "600px",
        zIndex: 1001,
        centered: true
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_211, [_hoisted_212, _createVNode(_component_a_divider, {
          style: {
            "margin": "10px 30px 10px 20px",
            "min-width": "0px",
            "flex": "1"
          }
        })])]),
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_218, [_createVNode(_component_a_divider, {
          style: {
            "margin": "10px 30px 10px 0px",
            "min-width": "0px"
          }
        }), _createVNode(_component_a_button, {
          class: "sts-button default",
          key: "back",
          onClick: onGroupAggCancel
        }, {
          default: _withCtx(() => [_createTextVNode("Cancel")]),
          _: 1
        }), _createVNode(_component_a_button, {
          class: "sts-button green",
          key: "submit",
          type: "primary",
          loading: _ctx.loading,
          onClick: onGroupAggConfirm
        }, {
          default: _withCtx(() => [_createTextVNode("Confirm")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_213, [_hoisted_214, _createVNode(_component_a_radio_group, {
          value: groupRadio.value,
          "onUpdate:value": _cache[28] || (_cache[28] = $event => groupRadio.value = $event),
          name: "radioGroup",
          size: "large"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(updateGroupAggFormData.groups, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              style: {
                "display": "flex",
                "align-items": "center",
                "margin-top": "10px"
              }
            }, [_createVNode(_component_a_select, {
              dropdownMatchSelectWidth: false,
              options: filterColumnGroupAggData.groupColumns,
              popupClassName: "sts-select-dropdown",
              value: item.activityStatsItemGroupField,
              "onUpdate:value": $event => item.activityStatsItemGroupField = $event,
              style: {
                "width": "200px"
              },
              onChange: onGroupColumnChange
            }, {
              suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                class: "ant-select-suffix"
              })]),
              _: 2
            }, 1032, ["options", "value", "onUpdate:value"]), _createVNode(_component_a_radio, {
              value: index
            }, null, 8, ["value"]), index === updateGroupAggFormData.groups.length - 1 ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              shape: "circle",
              onClick: $event => onAddGroupColumn(item),
              style: {
                "width": "24px",
                "height": "24px",
                "padding": "0px",
                "min-width": "unset",
                "border": "0",
                "margin-left": "2px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_svg_icon, {
                iconName: "add",
                iconColor: '#777777',
                iconSize: "24px"
              })]),
              _: 2
            }, 1032, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_a_button, {
              shape: "circle",
              onClick: $event => onDecreaseGroupColumn(item, index),
              style: {
                "width": "24px",
                "height": "24px",
                "padding": "0px",
                "min-width": "unset",
                "border": "0",
                "margin-left": "2px",
                "margin-bottom": "5px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_svg_icon, {
                iconName: "decrease",
                iconColor: '#ff0000',
                iconSize: "26px"
              })]),
              _: 2
            }, 1032, ["onClick"])]);
          }), 128))]),
          _: 1
        }, 8, ["value"]), _createVNode(_unref(Divider)), _hoisted_215, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(updateGroupAggFormData.aggs, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            style: {
              "display": "flex",
              "align-items": "center",
              "margin-top": "10px"
            }
          }, [_createVNode(_component_a_select, {
            dropdownMatchSelectWidth: false,
            options: filterColumnGroupAggData.aggColumns,
            popupClassName: "sts-select-dropdown",
            value: item.activityStatsItemAggField,
            "onUpdate:value": $event => item.activityStatsItemAggField = $event,
            style: {
              "width": "200px"
            },
            onChange: $event => onGroupAggChange(item)
          }, {
            suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
              class: "ant-select-suffix"
            })]),
            _: 2
          }, 1032, ["options", "value", "onUpdate:value", "onChange"]), _createElementVNode("div", _hoisted_216, [index === updateGroupAggFormData.aggs.length - 1 ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            shape: "circle",
            onClick: $event => onAddAggColumn(item),
            style: {
              "width": "24px",
              "height": "24px",
              "padding": "0px",
              "min-width": "unset",
              "border": "0",
              "margin-left": "10px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_svg_icon, {
              iconName: "add",
              iconColor: '#777777',
              iconSize: "24px"
            })]),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_a_button, {
            shape: "circle",
            onClick: $event => onDecreaseAggColumn(item),
            style: {
              "width": "24px",
              "height": "24px",
              "padding": "0px",
              "min-width": "unset",
              "border": "0",
              "margin-left": "10px",
              "margin-bottom": "5px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_svg_icon, {
              iconName: "decrease",
              iconColor: '#ff0000',
              iconSize: "26px"
            })]),
            _: 2
          }, 1032, ["onClick"])]), _hoisted_217, _createVNode(_component_a_select, {
            dropdownMatchSelectWidth: false,
            options: item.shownOptions,
            popupClassName: "sts-select-dropdown",
            value: item.shownId,
            "onUpdate:value": $event => item.shownId = $event,
            style: {
              "width": "200px"
            }
          }, {
            suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
              class: "ant-select-suffix"
            })]),
            _: 2
          }, 1032, ["options", "value", "onUpdate:value"])]);
        }), 128))])]),
        _: 1
      }, 8, ["open"]), _createVNode(_component_a_modal, {
        open: downloadStatsItemOpen.value,
        "onUpdate:open": _cache[31] || (_cache[31] = $event => downloadStatsItemOpen.value = $event),
        closable: false,
        width: "450px",
        zIndex: 1001,
        centered: true
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_219, [_hoisted_220, _createVNode(_component_a_divider, {
          style: {
            "margin": "10px 30px 10px 20px",
            "min-width": "0px",
            "flex": "1"
          }
        })])]),
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_226, [_createVNode(_component_a_divider, {
          style: {
            "margin": "10px 30px 10px 0px",
            "min-width": "0px"
          }
        }), _createVNode(_component_a_button, {
          class: "sts-button default",
          key: "back",
          onClick: onDownloadStatsItemCancel
        }, {
          default: _withCtx(() => [_createTextVNode("Cancel")]),
          _: 1
        }), _createVNode(_component_a_button, {
          class: "sts-button green",
          key: "submit",
          type: "primary",
          loading: _ctx.loading,
          onClick: onDownloadStatsItemSubmit
        }, {
          default: _withCtx(() => [_createTextVNode("Download")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_221, [_createElementVNode("div", _hoisted_222, [_hoisted_223, _createVNode(_component_a_config_provider, {
          theme: {
            components: {
              DatePicker: {
                controlHeight: 25
              }
            },
            token: {
              borderRadius: 4
            }
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_a_range_picker, {
            status: downloadStatsItemValidMessage.dateRangeError != null ? 'error' : null,
            popupClassName: "sts-picker",
            value: downloadStatsItemData.dateRange,
            "onUpdate:value": _cache[30] || (_cache[30] = $event => downloadStatsItemData.dateRange = $event)
          }, {
            suffixIcon: _withCtx(() => []),
            _: 1
          }, 8, ["status", "value"])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_224, [downloadStatsItemValidMessage.dateRangeError != null ? (_openBlock(), _createElementBlock("span", _hoisted_225, _toDisplayString(downloadStatsItemValidMessage.dateRangeError), 1)) : _createCommentVNode("", true)])])]),
        _: 1
      }, 8, ["open"]), _createVNode(_component_a_modal, {
        open: updateGroupAggOpen2.value,
        "onUpdate:open": _cache[36] || (_cache[36] = $event => updateGroupAggOpen2.value = $event),
        closable: false,
        width: "600px",
        zIndex: 1001,
        centered: true
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_227, [_hoisted_228, _createVNode(_component_a_divider, {
          style: {
            "margin": "10px 30px 10px 20px",
            "min-width": "0px",
            "flex": "1"
          }
        })])]),
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_240, [_createVNode(_component_a_divider, {
          style: {
            "margin": "10px 30px 10px 0px",
            "min-width": "0px"
          }
        }), _createVNode(_component_a_button, {
          class: "sts-button default",
          key: "back",
          onClick: onGroupAggCancel2
        }, {
          default: _withCtx(() => [_createTextVNode("Cancel")]),
          _: 1
        }), _createVNode(_component_a_button, {
          class: "sts-button green",
          key: "submit",
          type: "primary",
          onClick: onGroupAggConfirm2
        }, {
          default: _withCtx(() => [_createTextVNode("Confirm")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_229, [_hoisted_230, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterData.choose, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            style: {
              "display": "flex",
              "align-items": "center",
              "margin-top": "10px"
            },
            key: index
          }, [_createVNode(_component_a_select, {
            dropdownMatchSelectWidth: false,
            value: item.title,
            "onUpdate:value": $event => item.title = $event,
            popupClassName: "sts-select-dropdown",
            style: {
              "width": "200px"
            },
            disabled: ""
          }, {
            suffixIcon: _withCtx(() => []),
            _: 2
          }, 1032, ["value", "onUpdate:value"]), _hoisted_231, _createElementVNode("div", _hoisted_232, [_createVNode(_component_a_input, {
            value: item.search,
            "onUpdate:value": $event => item.search = $event,
            placeholder: "input search text",
            style: {
              "width": "300px"
            },
            disabled: ""
          }, null, 8, ["value", "onUpdate:value"]), _hoisted_233]), _createElementVNode("div", _hoisted_234, [_createVNode(_component_a_button, {
            shape: "circle",
            onClick: $event => deleteFilter(index),
            style: {
              "width": "24px",
              "height": "24px",
              "padding": "0px",
              "min-width": "unset",
              "border": "0",
              "margin-left": "10px",
              "margin-bottom": "5px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_svg_icon, {
              iconName: "decrease",
              iconColor: '#ff0000',
              iconSize: "26px"
            })]),
            _: 2
          }, 1032, ["onClick"])])]);
        }), 128)), filterData.noChoose.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_235, [_createVNode(_component_a_select, {
          dropdownMatchSelectWidth: false,
          options: filterData.noChoose,
          value: filterValue.value,
          "onUpdate:value": _cache[32] || (_cache[32] = $event => filterValue.value = $event),
          popupClassName: "sts-select-dropdown",
          style: _normalizeStyle({
            width: '200px !important',
            border: filterValueError.value ? '1px solid red' : ''
          }),
          fieldNames: {
            label: 'title',
            value: 'name'
          },
          onChange: _cache[33] || (_cache[33] = $event => filterValueError.value = false)
        }, {
          suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
            class: "ant-select-suffix"
          })]),
          _: 1
        }, 8, ["options", "value", "style"]), _hoisted_236, _createElementVNode("div", _hoisted_237, [_createVNode(_component_a_input, {
          value: filterSearch.value,
          "onUpdate:value": _cache[34] || (_cache[34] = $event => filterSearch.value = $event),
          placeholder: "input search text",
          style: _normalizeStyle({
            'width': '300px',
            'border': filterSearchError.value ? '1px solid red' : ''
          }),
          onInput: handleInput
        }, null, 8, ["value", "style"]), filterSearchError.value ? (_openBlock(), _createElementBlock("div", _hoisted_238, " 不能输入\" or \"或\" and \"！ ")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_239, [_createVNode(_component_a_button, {
          shape: "circle",
          onClick: _cache[35] || (_cache[35] = $event => addFilter()),
          style: {
            "width": "24px",
            "height": "24px",
            "padding": "0px",
            "min-width": "unset",
            "border": "0",
            "margin-left": "10px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_svg_icon, {
            iconName: "add",
            iconColor: '#777777',
            iconSize: "24px"
          })]),
          _: 1
        })])])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["open"])], 64);
    };
  }
};